import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Formik, FieldArray, Field } from "formik";
import * as Yup from "yup";
import { Select } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Alert from "react-bootstrap/Alert";
import moment from "moment";
import {
  ElementsConsumer,
  AuBankAccountElement,
  CardElement,
} from "@stripe/react-stripe-js";
import TextField from "@material-ui/core/TextField";
import { Autocomplete } from "@material-ui/lab";
import { Input } from "../../../../_metronic/_partials/controls";
import baseApi from "../../../../api/baseApi";
import { toast } from "../../../components/Toastr";
import {
  DATE_FORMAT,
  FREE_KIT_DATE,
  genderOptions,
  getSuburbs,
  merchandiseOptions,
  parseEnrolmentFormClassName,
  paymentMethods,
  photoVideoPermissionOptions,
} from "../../../Common/commonMethods";
import SearchableField from "../../../components/SearchableField";
import { SelectField } from "../../Lessons/View/MultiSelect";
import LogoSection from "../../../components/LogoSection";
import TermsComponent from "../../../components/TermsComponent";
import PaymentMessage from "../../../components/PaymentMessage";
import ThankUMessage from "../../../components/ThankUMessage";
import WeeklySearchMapComponent from "../WeeklyEnrolmentsMap/index";
import {
  CHILD_FIELDS,
  AU_BANK_ACCOUNT_ELEMENT_OPTIONS,
  selectedClassHelper,
  isClassFullHelper,
  priceCalculateHelper,
  parseLessonsNamesHelper,
  parseLessonsNames,
  renderLessonVenueName,
  SELECT_TERM_OPTIONS,
  renderCapacityCheckText,
} from "../../../Common/enrolmentHelpers";
import MutiSelectableField from "../../../components/MultiSelectableField";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import { constrainPoint } from "@fullcalendar/react";
import {
  cardAndBankChargesHelper,
  cardAndBankChargesWithTotalHelper
} from "../../../Common/enrolmentHelpers"
import { hearAboutUsOptions } from "../.././../Common/commonMethods";

const getEnrolmentHeader = (selectedClass) => {
  try {
    var postObject = JSON.stringify({
      event: "iframeFormSubmit",
      form: selectedClass?.service?.service,
    });
    window.parent.postMessage(postObject, "https://gingersport.com.au");
  } catch (e) {
    window.console && window.console.log(e);
  }
};

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: "100%",
  },
}));

const EnrolmentSchema = Yup.object().shape({
  classId: Yup.string().required("Required"),
  parentFirstName: Yup.string().required("Required"),
  parentLastName: Yup.string().required("Required"),
  parentPhone: Yup.number().required("Please enter a valid phone number"),
  parentEmail: Yup.string()
    .email("Invalid email")
    .required("Required"),
  termsAndConditions: Yup.boolean().oneOf(
    [true],
    "You must accept the terms and conditions."
  ),
  isKitMandatory: Yup.boolean(),
  childs: Yup.array().of(
    Yup.object().shape({
      childFirstName: Yup.string().required("Required"),
      childLastName: Yup.string().required("Required"),
      childDOB: Yup.string().required("Required"),
      attendedQuest: Yup.string(),
      isSizeAndQuantityRequired: Yup.boolean(),
      merchandise: Yup.string(),
      isQuestWeekly: Yup.boolean(),
    })
  ),
  paymentOptionValidation: Yup.boolean(),
  paymentOption: Yup.string().when("paymentOptionValidation", {
    is: true,
    then: Yup.string().required("Please select a Payment Option."),
  }),
});

const filterOptions = (options, filter) => {
  if (!filter) {
    return options;
  }

  const re = new RegExp(filter, "i");
  return options.filter(({ label }) => label && label.match(re));
};

const renderTerms = (terms) => {
  const requiredTerms = [];
  const thisTerm = terms?.find((term) => term?.status === "current");

  requiredTerms.push({ ...thisTerm, text: "This Term", value: "this" });

  let nextTermName = "";
  if (thisTerm?.name === "Term 1") {
    nextTermName = "Term 2";
  } else if (thisTerm?.name === "Term 2") {
    nextTermName = "Term 3";
  } else if (thisTerm?.name === "Term 3") {
    nextTermName = "Term 4";
  } else if (thisTerm?.name === "Term 4") {
    nextTermName = "Term 1";
  }

  const nextTerm = terms?.find((term) => term?.name === nextTermName);

  requiredTerms.push({ ...nextTerm, text: "Next Term", value: "next" });

  return requiredTerms;
};

const EnrolmentForm = (props) => {
  const {
    classes,
    selectedLocation,
    exist,
    message,
    error,
    showModal,
    onChangeHandler,
    match,
    locations,
    selectedLocationHandler,
    products,
    parent,
    history,
    stripePublishableKey,
    initialFormValues,
    students,
    couponValidateMessage,
    onCouponChangeHandler,
    coupon,
    user,
    changeCouponValidationMessage,
    changeEmailMessage,
    term,
    selectedLessons,
    setShowLoginForm,
    onClickLogout,
    onTermChangeHandler,
    terms,
    classesByLocationLoading,
    loadingLocations,
    ages,
    questSetting,
    gingerSetting,
    business,
  } = props;

  const styleClasses = useStyles();

  const [enrolmentError, setEnrolmentError] = useState(null);
  const [noChildError, setNoChildError] = useState(null);
  const [selected, setSelected] = useState([]);
  const [selectedClass, setSelectedClass] = useState({});
  const [spin, setSpin] = useState(false);
  const [show, setShow] = useState(false);
  const [selectedClasses, setClasses] = useState([]);
  const [childcareMessage, setChildcareMessage] = useState("");
  const enrolmentDate = moment(new Date()).format(DATE_FORMAT);

  const attendedQuest = (childs, index) => {
    childs[index].attendedQuest = 'yes'
  }
  const isFreeKit = moment(FREE_KIT_DATE, DATE_FORMAT).isAfter(
    moment(enrolmentDate, DATE_FORMAT)
  );
  useEffect(() => {
    if (Array.isArray(selectedLessons)) {
      setSelected(selectedLessons);
    }
  }, [selectedLessons]);

  useEffect(() => {
    if (match.params.classId) {
      const selectedClass = selectedClassHelper({
        classId: match.params.classId,
        classes: classes,
      });

      if (selectedClass?.payment?.length === 1) {
        setSelected(
          parseLessonsNames({
            classId: match.params.classId,
            classes: classes,
            term,
            paymentOption:
              selectedClass?.payment?.length === 1
                ? selectedClass.payment.includes("fixed")
                  ? "full"
                  : selectedClass.payment.includes("term")
                    ? "term"
                    : selectedClass.payment.includes("monthly")
                      ? "monthly"
                      : ""
                : "",
            terms,
          })?.sessions?.map((session) => ({
            value: session?._id,
            label: session?.date,
            isMatchDay: session?.matchDay,
          }))
        );
      } else if (selectedClass?.paymentType === "free") {
        setSelected(
          parseLessonsNames({
            classId: match.params.classId,
            classes: classes,
            term,
            terms,
          })?.sessions?.map((session) => ({
            value: session?._id,
            label: session?.date,
            isMatchDay: session?.matchDay,
          }))
        );
      }
    }
  }, [match]);

  const getInputClasses = (meta) => {
    let result = "form-control";
    if (meta.touched && meta.error) {
      result += " is-invalid";
    }

    if (meta.touched && !meta.error) {
      result += " is-valid";
    }

    return result;
  };

  const submitHandler = async (values, resetForm) => {
    if (!values?.classId?.value) {
      return toast.error("Please select a class");
    }

    setSpin(true);
    if (
      (user &&
        user.roleId.name === "parent" &&
        user.business === match.params.business &&
        values.studentIds &&
        values.studentIds.length === 0 &&
        values.childs.length === 0) ||
      (user &&
        user.roleId.name === "parent" &&
        user.business === match.params.business &&
        values.studentIds === null &&
        values.childs.length === 0)
    ) {
      setSpin(false);

      return setNoChildError("Please select a child.");
    }

    console.log({ "Inside submit": values });

    const totalAmount =
      selectedClassHelper({
        classId: values?.classId?.value,
        classes,
      })?.paymentType === "paid" ||
      priceCalculateHelper({
        selectedClass: selectedClassHelper({
          classId: values?.classId?.value,
          classes,
        }),
        values,
        selectedCoupon: coupon,
        lessons: selected?.map((lesson) => lesson?.value),
      })?.totalAmountToPay;

    console.log({ totalAmount });

    if (
      totalAmount > 0 ||
      isClassFullHelper(
        selectedClassHelper({
          classId: values?.classId?.value,
          classes,
        })
      ) ||
      (!priceCalculateHelper({
        selectedClass: selectedClassHelper({
          classId: values?.classId?.value,
          classes,
        }),
        values,
        selectedCoupon: coupon,
        lessons: selected?.map((lesson) => lesson?.value),
      })?.paid &&
        values.paymentOption === "full") ||
      (selectedClassHelper({
        classId: values?.classId?.value,
        classes,
      })?.paymentType === "paid" &&
        stripePublishableKey)
    ) {
      console.log("First If Block");
      const parentStipeCustomer =
        user &&
        user?.roleId.name === "parent" &&
        user?.stripe_customer_id &&
        user?.business === match.params.business;

      const paymentMethods =
        user?.stripe_customer_id &&
        user?.paymentMethods?.bankAccounts?.length === 0 &&
        user?.stripe_customer_id &&
        user?.paymentMethods?.allCards?.length === 0;
      console.log(user);
      if (
        (!parentStipeCustomer &&
          isClassFullHelper(
            selectedClassHelper({
              classId: values?.classId?.value,
              classes,
            })
          )) ||
        paymentMethods ||
        (!parentStipeCustomer &&
          !(
            !priceCalculateHelper({
              selectedClass: selectedClassHelper({
                classId: values?.classId?.value,
                classes,
              }),
              values,
              selectedCoupon: coupon,
              lessons: selected?.map((lesson) => lesson?.value),
            })?.paid && values.paymentOption === "full"
          )) ||
        (!parentStipeCustomer && totalAmount > 0)
      ) {
        console.log("Second If Block");

        const calculatedAmounts = priceCalculateHelper({
          selectedClass: selectedClassHelper({
            classId: values?.classId?.value,
            classes,
          }),
          values,
          selectedCoupon: coupon,
          lessons: selected?.map((lesson) => lesson?.value),
        });

        const { stripe, elements } = props;

        if (!stripe || !elements) {
          console.log("Return Block");
          // Stripe.js has not yet loaded.
          // Make sure to disable form submission until Stripe.js has loaded.
          setSpin(false);

          return;
        }

        const cardElement = elements.getElement(CardElement);
        if (values.paymentType == "credit") {
          // if (calculatedAmounts?.paid) {
          const { token } = await stripe.createToken(cardElement);

          if (token) {
            values.stripeId = token.id;
          } else {
            setSpin(false);
            return;
            // }
          }
        } else {
          const email = values.parentEmail;
          const name = `${values.parentFirstName} ${values.parentLastName}`;
          const auBankAccount = elements.getElement(AuBankAccountElement);

          let business = selectedClassHelper({
            classId: values?.classId?.value,
            classes,
          })?.business;

          let apiresult = {};
          try {
            apiresult = await baseApi.post(`/stripe/create-payment-intent`, {
              paymentOption: values.paymentOption,
              paymentType: values.paymentType,
              classId: values.classId.value,
              email,
              name,
              business,
              organisationUuid: match.params.uuid,
              studentIds:
                values.studentIds && values.studentIds.map((st) => st.value),
              childs: values.childs.map((child) => {
                return {
                  ...child,

                  childDOB: moment(child.childDOB, "YYYY-MM-DD").format(
                    DATE_FORMAT
                  ),
                };
              }),
            });
          } catch (error) {
            console.log(error);
            console.log(error.response);
            setSpin(false);
            console.log(error.response);
            if (error?.response?.data && error?.response?.data?.message) {
              setEnrolmentError(error.response.data.message);
              return toast.error(error.response.data.message);
            }
            if (
              error?.response?.data?.code === 11000 &&
              error?.response?.data?.name === "MongoError"
            ) {
              return toast.error("Email already exist.");
            }
            toast.error(
              "Enrolment cannot be created right now. Please try after some time."
            );
          }

          const confirmationResult = await stripe.confirmAuBecsDebitSetup(
            apiresult.data.clientSecret,
            {
              payment_method: {
                au_becs_debit: auBankAccount,
                billing_details: {
                  name,
                  email,
                },
              },
            }
          );

          if (confirmationResult.error) {
            // Show error to your customer.
            console.log(confirmationResult.error.message);
            toast.error(confirmationResult.error.message);
            setSpin(false);
            return;
          } else {
            const { setupIntent } = confirmationResult;
            if (confirmationResult.setupIntent.status == "succeeded") {
              values.stripePaymentMethod = setupIntent.id;
              values.stripeCustomerId = apiresult.data.stripeCustomerId;
            }
            // Show a confirmation message to your customer.
            // The SetupIntent is in the 'succeeded' state.
          }
        }
      }
      const selectedClass = selectedClassHelper({
        classId: values?.classId?.value,
        classes,
      });

      setSelectedClass(selectedClass);

      console.log("Before Submit");
      baseApi
        .post("/enrolment/createEnrolment", {
          ...values,
          kitMandatory: selectedClass?.kit_mandatory,
          lessons:
            values?.term === "next" && values?.paymentOption === "term"
              ? selected?.map((lesson) => lesson.value)
              //  ? []
              : selected?.map((lesson) => lesson.value),

          size:
            (selectedClass?.product &&
              selectedClass?.kit_mandatory &&
              values.childs.some((child) => child.merchandise === "no")) ||
              (values.paymentOption === "full" &&
                isFreeKit &&
                values.childs.every((child) => child.merchandise === "no")) ||
              (values.paymentOption === "full" &&
                isFreeKit &&
                values.childs.every(
                  (child) => child.merchandise === "yes" && !child.size
                ))
              ? values.size
              : null,
          type: match.url.includes("enrolment") ? "childcare" : "weekly",
          business: match.params.business,
          venue: selectedLocation,
          classId: values.classId.value,
          studentIds:
            values.studentIds && values.studentIds.map((st) => st.value),
          parentId:
            user &&
              user.roleId.name === "parent" &&
              user.business === match.params.business
              ? user._id
              : null,
          childs:
            values.childs &&
            values.childs.map((child) => {
              return {
                ...child,
                size:
                  (selectedClass?.product &&
                    !selectedClass?.kit_mandatory &&
                    !values.isQuestWeekly &&
                    child.merchandise === "yes" &&
                    child.quantity) ||
                    (selectedClass?.product &&
                      values.isQuestWeekly &&
                      child.attendedQuest === "no" &&
                      child.quantity) ||
                    (!values.isQuestWeekly &&
                      selectedClass?.kit_mandatory &&
                      child.attendedQuest === "no" &&
                      child.quantity)
                    ? child.size
                    : null,
                quantity:
                  (!values.isQuestWeekly &&
                    !selectedClass?.kit_mandatory &&
                    child.merchandise === "yes") ||
                    (selectedClass?.product &&
                      values.isQuestWeekly &&
                      child.attendedQuest === "no" &&
                      child.quantity) ||
                    (!values.isQuestWeekly &&
                      selectedClass?.kit_mandatory &&
                      child.attendedQuest === "no" &&
                      child.quantity)
                    ? child.quantity
                    : null,
                personalisationDetails : child.personalisationDetails ? child.personalisationDetails : null,
                childDOB: moment(child.childDOB, "YYYY-MM-DD").format(
                  DATE_FORMAT
                ),
                // childClassIds: child?.childClassIds?.map((cls) => cls.value),
              };
            }),
        })
        .then((result) => {
          setEnrolmentError(null);

          setSpin(false);
          setShow(true);
          if (
            values.paymentOption === "monthly" &&
            match.url.includes("enrolment")
          ) {
            if (result?.data?.createdTransactions.length === 0) {
              setChildcareMessage(
                `We've got your request to book into Childcare Fun Soccer.`
              );
            } else if (
              result?.data?.createdTransactions.some(
                (transaction) =>
                  transaction.reason === "Booking monthly installment."
              )
            ) {
              setChildcareMessage(`We've got your request to book into Childcare Fun Soccer.
              We've billed you for the remaining sessions in the month (up to the first Sunday of next month).<br/>
              All future payments will be billed on the first Sunday of each month.`);
            } else if (result?.data?.orderedItems?.length > 0) {
              setChildcareMessage(`We've got your request to book into Childcare Fun Soccer.
              We've taken payment for your new soccer kit, and we'll be sending it out to you soon.`);
            }
          }
          if (
            values.paymentOption === "full" &&
            match.url.includes("enrolment")
          ) {
            if (
              result?.data?.createdTransactions?.length > 0 &&
              result?.data?.orderedItems?.length > 0
            ) {
              setChildcareMessage(`We've got your request to book into Childcare Fun Soccer.<br/>
              We've taken payment for your new soccer kit, and we'll be sending it out to you soon.`);
            }
          }

          if (
            Array.isArray(result?.data?.waitingList) &&
            result?.data?.waitingList.length > 0
          ) {
            setChildcareMessage(`The session is full, so we've put you on the waiting list.
            We'll let you know if a place becomes available.`);
          }

          toast.success("Enrolment successfully created!");
          resetForm(initialFormValues);
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response);
          setSpin(false);
          console.log(error.response);
          if (error?.response?.data && error?.response?.data?.message) {
            setEnrolmentError(error.response.data.message);
            return toast.error(error.response.data.message);
          }
          if (
            error?.response?.data?.code === 11000 &&
            error?.response?.data?.name === "MongoError"
          ) {
            return toast.error("Email already exist.");
          }
          toast.error(
            "Enrolment cannot be created right now. Please try after some time."
          );
        });
    } else {
      setSpin(true);
      // let freeLessons = parseLessonsNames({
      //   classId: values.classId.value,
      //   classes,
      //   term,
      //   paymentOption: "full",
      // })?.sessions;

      baseApi
        .post("/enrolment/createEnrolment", {
          ...values,
          size: null,
          lessons:
            values?.term === "next" && values?.paymentOption === "term"
              ? selected?.map((lesson) => lesson.value)
              // ? []
              : selected?.map((lesson) => lesson.value),
          paymentOption: null,
          type: match.url.includes("enrolment") ? "childcare" : "weekly",
          business: match.params.business,
          classId: values.classId ? values.classId.value : null,
          studentIds: values.studentIds
            ? values.studentIds.map((st) => st.value)
            : null,
          parentId:
            user &&
              user.roleId.name === "parent" &&
              user.business === match.params.business
              ? user._id
              : null,
          paymentType: "free",
          venue: selectedLocation,
          childs:
            values.childs &&
            values.childs.map((child) => {
              return {
                ...child,
                size: null,
                quantity: null,
                childDOB: moment(child.childDOB, "YYYY-MM-DD").format(
                  DATE_FORMAT
                ),
                childClassIds: child?.childClassIds?.map((cls) => cls.value),
              };
            }),
        })
        .then((result) => {
          setEnrolmentError(null);

          setSpin(false);
          setShow(true);

          toast.success("Enrolment successfully created!");
          resetForm(initialFormValues);
        })
        .catch((error) => {
          console.log(error?.response?.data);
          setSpin(false);
          if (error?.response?.data && error?.response?.data?.message) {
            setEnrolmentError(error.response.data.message);

            return toast.error(error.response.data.message);
          }

          if (
            error?.response?.data?.code === 11000 &&
            error?.response?.data?.name === "MongoError"
          ) {
            return toast.error("Email already exist.");
          }

          toast.error(
            "Enrolment cannot be created right now. Please try after some time."
          );
        });
    }
  };

  const validateSize = (values, classes, index) => {
    const isMandatory = selectedClassHelper({
      classId: values?.classId?.value,
      classes,
    })?.kit_mandatory;

    let error;
    if (isMandatory || values.isQuestWeekly) {
      if (
        document.querySelector(
          `input[name='childs.[${index}].attendedQuest']:checked`
        )?.value === "yes" &&
        !document.querySelector("#size")?.value
      ) {
        error = "Required";
      }
    } else {
      if (
        document.querySelector(
          `input[name='childs.[${index}].merchandise']:checked`
        )?.value === "yes" &&
        !document.querySelector("#size")?.value
      ) {
        error = "Required";
      }
    }

    return error;
  };

  const validateQuantity = (values, classes, index) => {
    const isMandatory = selectedClassHelper({
      classId: values?.classId?.value,
      classes,
    })?.kit_mandatory;

    let error;
    if (isMandatory || values.isQuestWeekly) {
      if (
        document.querySelector(
          `input[name='childs.[${index}].attendedQuest']:checked`
        )?.value === "yes" &&
        !document.querySelector("#quantity")?.value
      ) {
        error = "Required";
      }
    } else {
      if (
        document.querySelector(
          `input[name='childs.[${index}].merchandise']:checked`
        )?.value === "yes" &&
        !document.querySelector("#quantity")?.value
      ) {
        error = "Required";
      }
    }

    if (parseInt(document.querySelector("#quantity")?.value) <= 0) {
      error = "Please enter a valid value.";
    }

    return error;
  };

  const validatePaymentOption = (values, classes) => {
    const isPaid =
      selectedClassHelper({
        classId: values?.classId?.value,
        classes,
      })?.paymentType === "paid" &&
      !isClassFullHelper(
        selectedClassHelper({
          classId: values?.classId?.value,
          classes,
        })
      );

    let error;
    if (isPaid) {
      if (!document.querySelector("#paymentOption")?.value) {
        error = "Required";
      }
    }

    return error;
  };

  const validateTerm = (values) => {
    let error;
    if (
      match.url.includes("weekly") &&
      !match.url.includes("selected-location") &&
      !match.params.classId &&
      !match.params.tag &&
      !values.term
    ) {
      if (!document.querySelector("#term")?.value) {
        error = "Required";
      }
    }

    return error;
  };

  const validateKitSize = (values, cls) => {
    let error;
    if (
      (isFreeKit &&
        cls?.include_kit &&
        cls?.product &&
        cls?.service?.service === "Childcare Fun Soccer" &&
        values.childs.every((child) => child.merchandise === "no") &&
        values?.paymentOption === "full") ||
      (isFreeKit &&
        cls?.include_kit &&
        cls?.product &&
        cls?.service?.service === "Weekly Fun Soccer" &&
        values.childs.every((child) => child.merchandise === "no") &&
        values?.paymentOption === "full")
    ) {
      if (!document.querySelector("#size")?.value) {
        error = "Required";
      }
    }

    return error;
  };

  return (
    <div style={{ padding: 20 }}>
      {/* <Helmet>
        <script async={true}>
          {(function(w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
            var f = d.getElementsByTagName(s)[0],
              j = d.createElement(s),
              dl = l != "dataLayer" ? "&l=" + l : "";
            j.async = true;
            j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
            f.parentNode.insertBefore(j, f);
          })(window, document, "script", "dataLayer", "GTM-5KKQB9Q")}
        </script>
      </Helmet> */}
      {show ? (
        <>
          <Helmet>
            <script async={true}>{getEnrolmentHeader(selectedClass)}</script>
          </Helmet>

          <ThankUMessage
            match={match}
            setShow={setShow}
            childcareMessage={childcareMessage}
            history={props.history}
            changeEmailMessage={changeEmailMessage}
            changeCouponValidationMessage={changeCouponValidationMessage}
          />
        </>
      ) : (
        <>
          <Formik
            enableReinitialize={true}
            initialValues={initialFormValues}
            validationSchema={EnrolmentSchema}
            onSubmit={(values, { resetForm }) => {
              submitHandler(values, resetForm);
            }}
          >
            {({
              values,
              handleSubmit,
              setFieldValue,
              setFieldTouched,
              errors,
              touched,
            }) => (
              <>
                <div
                  style={
                    match.url.includes("weekly") &&
                      !match.params.classId &&
                      !match.params.tag &&
                      !match.url.includes("selected-location")
                      ? null
                      : { maxWidth: "1000px", margin: "auto" }
                  }
                >
                  {match.params.classId && (
                    <>
                      <table>
                        <tr>
                          <th>
                            <h5>

                              <LogoSection
                                match={match}
                                childcareCentre={
                                  Array.isArray(classes) && classes.length > 0
                                    ? classes[0].location
                                    : null
                                }
                              />
                            </h5>
                          </th>
                          <td>

                          </td>
                        </tr>
                        <tr>
                          <th>
                            <h5>
                              {"  "}
                              {Array.isArray(classes) && classes.length > 0
                                ? classes[0].name
                                : null}
                            </h5>
                          </th>
                          <td>
                            <h5>

                            </h5>
                          </td>
                        </tr>

                      </table>
                    </>
                  )}
                  {user &&
                    user.roleId.name === "parent" &&
                    user.business === match.params.business ? (
                    <h5>
                      <strong>
                        Already Logged in?{" "}
                        <a href="javascript:void(null)" onClick={onClickLogout}>
                          Logout
                        </a>
                      </strong>
                    </h5>
                  ) : (
                    <h5>
                      <strong>
                        Already have an account?{" "}
                        <a
                          href="javascript:void(null)"
                          onClick={setShowLoginForm}
                        >
                          Log in here
                        </a>
                      </strong>
                    </h5>
                  )}
                  <br />

                  <form
                    onSubmit={handleSubmit}
                    noValidate
                    autoComplete="off"
                    className={`form ${selectedClassHelper({
                      classId: values?.classId?.value,
                      classes,
                    })?._id
                      ? selectedClassHelper({
                        classId: values?.classId?.value,
                        classes,
                      })?.service?.service?.replace(/\s/g, "-")
                      : ""
                      }`}
                  >
                    {/* {match.url.includes("weekly") &&
                      !match.url.includes("selected-location") &&
                      !match.params.classId &&
                      !match.params.tag && (
                        <>
                          <div className="row">
                            <div className="col-sm-12 col-md-12">
                              <div className="form-group">
                                <Field
                                  type="select"
                                  name="term"
                                  component={Select}
                                  validate={() => validateTerm(values)}
                                >
                                  {({ field, form, meta }) => (
                                    <div>
                                      <label>Select Term</label>
                                      <select
                                        {...field}
                                        className={`${getInputClasses(meta)}`}
                                        name="term"
                                        id="term"
                                        onChange={(e) => {
                                          onTermChangeHandler(e.target.value);
                                          setFieldValue("selectedSuburb", "");
                                          setFieldValue("location", "");
                                          setFieldValue("classId", "");

                                          setFieldValue("term", e.target.value);
                                        }}
                                      >
                                        <option value="">Select</option>
                                        {renderTerms(terms)?.map((term) => (
                                          <option
                                            key={term?._id}
                                            value={term?.value}
                                          >
                                            {`${term?.text} - ${term?.startDate} - ${term?.endDate}`}
                                          </option>
                                        ))}
                                      </select>

                                      {meta.touched && meta.error && (
                                        <div className="error invalid-feedback">
                                          {meta.error}
                                        </div>
                                      )}
                                    </div>
                                  )}
                                </Field>
                              </div>
                            </div>
                          </div>
                        </>
                      )} */}

                    {match.params.business === "ginger" &&
                      match.url.includes("/weekly/") &&
                      !match.url.includes("/selected-class/") &&
                      !match.url.includes("/class/weekly/") ? (
                      <div className="row">
                        <div className="col-sm-12 col-md-12">
                          <div className="form-group">
                            <Field
                              type="select"
                              name="ageGroup"
                              component={Select}
                            // validate={() => validateTerm(values)}
                            >
                              {({ field, form, meta }) => (
                                <div>
                                  <label>Select Age Group(Optional)</label>
                                  <select
                                    {...field}
                                    className={`${getInputClasses(meta)}`}
                                    name="ageGroup"
                                    id="ageGroup"
                                    onChange={(e) => {
                                      setFieldValue("venue", {});
                                      setFieldValue("selectedSuburb", {});
                                      setFieldValue("location", null);
                                      setFieldValue("classId", {});
                                      setFieldValue("ageGroup", e.target.value);
                                    }}
                                  >
                                    {[
                                      { name: "All", _id: "all" },
                                      ...ages,
                                    ]?.map((age) => (
                                      <option key={age?._id} value={age?._id}>
                                        {age?.name}
                                      </option>
                                    ))}
                                  </select>

                                  {meta.touched && meta.error && (
                                    <div className="error invalid-feedback">
                                      {meta.error}
                                    </div>
                                  )}
                                </div>
                              )}
                            </Field>
                          </div>
                        </div>
                      </div>
                    ) : null}
                    {(match.url.includes("enrolment") &&
                      !match.params.venue &&
                      !match.params.classId) ||
                      (match.url.includes("weekly") &&
                        !match.params.classId &&
                        !match.url.includes("selected-location")) ? (
                      <div className="row">
                        <div
                          className={`col-sm-12 ${match.url.includes("weekly")
                            ? "col-md-12"
                            : "col-md-12"
                            }`}
                        >
                          <div className="form-group">
                            {match.url.includes("/enrolment") ? (
                              <label>
                                Choose the suburb your child's centre is in
                              </label>
                            ) : (
                              <label>
                                Search our available session locations
                              </label>
                            )}
                            {loadingLocations ? (
                              <div>
                                <div class="d-flex justify-content-center">
                                  <div
                                    class="spinner-border"
                                    role="status"
                                  ></div>
                                  <span class="visually-hidden">
                                    Loading...
                                  </span>
                                </div>
                              </div>
                            ) : (
                              <SearchableField
                                placeholder="Search..."
                                id="selectedSuburb"
                                name="selectedSuburb"
                                options={
                                  !values?.searchBySuburbOrPostcode
                                    ? match.url.includes("weekly") &&
                                      !match.url.includes(
                                        "selected-location"
                                      ) &&
                                      match.params.business &&
                                      match.url.includes("/weekly/") &&
                                      !match.params.classId &&
                                      !match.params.tag
                                      ? getSuburbs(
                                        locations?.filter((location) =>
                                          !values?.ageGroup ||
                                            values?.ageGroup === "all"
                                            ? location?.classes?.some((cls) =>
                                              moment(
                                                cls?.to,
                                                DATE_FORMAT
                                              ).isSameOrAfter(moment())
                                                ? cls?.service &&
                                                  !cls?.capacity_check &&
                                                  match.params.business ===
                                                  "ginger"
                                                  ? cls?.service
                                                    ?.service ===
                                                  "Weekly Fun Soccer"
                                                  : cls?.service &&
                                                    match.params
                                                      .business === "quest"
                                                    ? cls?.service
                                                      ?.service ===
                                                    "Academy Football Coaching"
                                                    : false
                                                : false
                                            )
                                            : location?.classes?.some((cls) =>
                                              moment(
                                                cls?.to,
                                                DATE_FORMAT
                                              ).isSameOrAfter(moment())
                                                ? cls?.ageGroup?.includes(
                                                  values?.ageGroup
                                                ) &&
                                                  // !cls?.capacity_check &&
                                                  cls?.service &&
                                                  match.params.business ===
                                                  "ginger"
                                                  ? cls?.service
                                                    ?.service ===
                                                  "Weekly Fun Soccer"
                                                  : cls?.service &&
                                                    match.params
                                                      .business === "quest"
                                                    ? cls?.service
                                                      ?.service ===
                                                    "Academy Football Coaching"
                                                    : false
                                                : false
                                            )
                                        )
                                      )
                                      : match.params.tag
                                        ? getSuburbs(
                                          locations?.filter((location) => {
                                            return !values?.ageGroup ||
                                              values?.ageGroup === "all"
                                              ? location?.classes?.some((cls) =>
                                                moment(
                                                  cls?.to,
                                                  DATE_FORMAT
                                                ).isSameOrAfter(moment())
                                              )
                                              : location?.classes?.some(
                                                (cls) =>
                                                  moment(
                                                    cls?.to,
                                                    DATE_FORMAT
                                                  ).isSameOrAfter(moment()) &&
                                                  cls?.ageGroup?.includes(
                                                    values?.ageGroup
                                                  ) &&
                                                  cls?.tag?.includes(
                                                    match.params.tag
                                                  )
                                              );
                                          })
                                        )
                                        : getSuburbs(
                                          locations?.filter((location) =>
                                            !values?.ageGroup ||
                                              values?.ageGroup === "all"
                                              ? location?.classes?.some((cls) =>
                                                moment(
                                                  cls?.to,
                                                  DATE_FORMAT
                                                ).isSameOrAfter(moment())
                                              )
                                              : location?.classes?.some(
                                                (cls) =>
                                                  moment(
                                                    cls?.to,
                                                    DATE_FORMAT
                                                  ).isSameOrAfter(moment()) &&
                                                  cls?.ageGroup?.includes(
                                                    values?.ageGroup
                                                  )
                                              )
                                          )
                                        )
                                    : []
                                }
                                value={values.selectedSuburb}
                                isMulti={true}
                                onChange={(name, selectedSuburb) => {
                                  // if (venue && venue.value) {
                                  //   selectedLocationHandler(venue.value);
                                  // }
                                  setFieldValue("venue", {});
                                  setFieldValue("location", null);
                                  setFieldValue("classId", {});
                                  setFieldValue(name, selectedSuburb);
                                }}
                                onBlur={setFieldTouched}
                                touched={touched.selectedSuburb}
                                error={errors.selectedSuburb}
                                isClearable={true}
                                backspaceRemovesValue={true}
                              />
                            )}
                          </div>
                        </div>
                        {match.url.includes("weekly") &&
                          !match.url.includes("selected-location") &&
                          !match.params.tag && (
                            <div className="col-sm-12 col-md-12">
                              <div className="form-group">
                                <Field
                                  type="checkbox"
                                  name="searchBySuburbOrPostcode"
                                >
                                  {({ field, form, meta }) => (
                                    <>
                                      <label style={{ marginTop: "30px" }}>
                                        <input
                                          type="checkbox"
                                          name="searchBySuburbOrPostcode"
                                          {...field}
                                          onChange={(e) => {
                                            if (!e.target.checked) {
                                              setFieldValue("location", null);
                                            }

                                            if (e.target.checked) {
                                              setFieldValue(
                                                "selectedSuburb",
                                                ""
                                              );
                                            }

                                            setFieldValue("classId", "");
                                            setFieldValue(
                                              "searchBySuburbOrPostcode",
                                              e.target.checked
                                            );
                                          }}
                                        />{" "}
                                        Search by suburb or postcode
                                      </label>
                                      {meta.touched && meta.error && (
                                        <div
                                          style={{
                                            color: "#F64E60",
                                            fontWeight: 400,
                                            fontSize: "0.9rem",
                                          }}
                                        >
                                          {meta.error}
                                        </div>
                                      )}
                                    </>
                                  )}
                                </Field>
                              </div>
                            </div>
                          )}
                      </div>
                    ) : null}

                    {/* {values?.searchBySuburbOrPostcode && <>Testing</>} */}
                    {match.url.includes("enrolment") &&
                      !match.params.venue &&
                      !match.params.classId && (
                        <>
                          <div className="row">
                            <div className="col-sm-12 col-md-12">
                              <div className="form-group">
                                <label>Search Venue</label>
                                <SearchableField
                                  placeholder="Search..."
                                  id="venue"
                                  name="venue"
                                  options={
                                    values?.selectedSuburb
                                      ? locations?.filter(
                                        (location) =>
                                          location.suburb ===
                                          values?.selectedSuburb?.value
                                      )
                                      : locations
                                  }
                                  value={values.venue}
                                  isMulti={true}
                                  onChange={(name, venue) => {
                                    if (venue && venue.value) {
                                      selectedLocationHandler(venue.value);
                                    }
                                    setFieldValue(name, venue);
                                  }}
                                  onBlur={setFieldTouched}
                                  touched={touched.venue}
                                  error={errors.venue}
                                  isClearable={true}
                                  backspaceRemovesValue={true}
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    {match.url.includes("enrolment") && (
                      <div className="col-md-12">
                        {values?.venue?.value &&
                          locations?.find(
                            (location) => location?._id === values?.venue?.value
                          )?.venueImage && (
                            <span
                              style={{
                                cursor: "pointer",
                              }}
                            >
                              <Zoom>
                                <img
                                  // onClick={() => {
                                  //   setLgShow(true);
                                  //   setImageUrls(imageUrl);
                                  // }}
                                  className="ml-2"
                                  src={
                                    locations?.find(
                                      (location) =>
                                        location?._id === values?.venue?.value
                                    )?.venueImage
                                  }
                                  style={{
                                    height: 100,
                                    width: 100,
                                  }}
                                />
                              </Zoom>
                            </span>
                          )}
                      </div>
                    )}

                    {!classesByLocationLoading &&
                      values.venue &&
                      match.url.includes("/enrolment") &&
                      locations.some(
                        (location) =>
                          location._id === values.venue.value && !location.bac
                      ) &&
                      classes?.length === 0 && (
                        <div className="form-group">
                          <strong>
                            no sessions scheduled at this location.
                          </strong>
                        </div>
                      )}

                    {values.venue &&
                      match.url.includes("/enrolment") &&
                      locations.some(
                        (location) =>
                          location._id === values.venue.value && location.bac
                      ) && (
                        <div className="form-group">
                          <strong>
                            Great choice! The centre you have selected deals
                            with Ginger Sport on your behalf. Instead of booking
                            here, just get in touch with your centre & ask them
                            to book your child into Ginger Sport's fun soccer.
                            We can't wait to see your little one enjoying soccer
                            every week!
                          </strong>
                        </div>
                      )}

                    {match.url.includes("weekly") &&
                      !match.url.includes("selected-location") &&
                      values?.searchBySuburbOrPostcode &&
                      !match.params.classId &&
                      !match.params.tag ? (
                      <>
                        <WeeklySearchMapComponent
                          resetClassValue={setFieldValue}
                          match={match}
                          history={history}
                        />
                        <br />
                      </>
                    ) : null}

                    {!match.params.classId && (
                      <>
                        <div className="row">
                          {match.url.includes("weekly") &&
                            !match.url.includes("selected-location") &&
                            !values?.searchBySuburbOrPostcode ? (
                            //    ||
                            // (match.url.includes("weekly") &&
                            //   match?.params?.location &&
                            //   !match.url.includes("selected-location"))
                            <div className="col-sm-12 col-md-12">
                              <div className="form-group">
                                <label>Select Location</label>
                                <Autocomplete
                                  id="location"
                                  // className={`${getInputClasses(meta)}`}
                                  className="autosuggestion_field"
                                  name="location"
                                  options={
                                    values?.selectedSuburb
                                      ? locations?.filter(
                                        (location) =>
                                          location.suburb ===
                                          values?.selectedSuburb?.value
                                      )
                                      : []
                                  }
                                  getOptionLabel={(option) =>
                                    option &&
                                    option.suburb +
                                    "- " +
                                    option.name +
                                    "- " +
                                    " " +
                                    option.address +
                                    ", " +
                                    option.suburb +
                                    " " +
                                    option.name +
                                    " " +
                                    option.postcode
                                  }
                                  value={values?.location}
                                  onChange={(e, value) => {
                                    if (value && value._id) {
                                      selectedLocationHandler(
                                        value._id,
                                        values.term
                                      );
                                    }

                                    setFieldValue("classId", {});
                                    setFieldValue("location", value);
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      name="location"
                                      // label="Venue"
                                      variant="outlined"
                                    // fullWidth
                                    />
                                  )}
                                />
                              </div>
                            </div>
                          ) : null}
                        </div>

                        <div className="row">
                          {values.location && (
                            <LogoSection
                              match={match}
                              childcareCentre={locations
                                .filter(
                                  (location) =>
                                    location._id === values.location._id
                                )
                                .reduce(
                                  (obj, item) =>
                                    Object.assign(obj, { ...item }),
                                  {}
                                )}
                            />
                          )}

                          <div className="col-sm-12 col-md-12">
                            <div className="form-group">
                              <>
                                <label>
                                  {match.params.tag
                                    ? "Select Session"
                                    : "Select Class"}
                                </label>
                                {classesByLocationLoading ? (
                                  <div>
                                    <div class="d-flex justify-content-center">
                                      <div
                                        class="spinner-border"
                                        role="status"
                                      ></div>
                                      <span class="visually-hidden">
                                        Loading...
                                      </span>
                                    </div>
                                  </div>
                                ) : (
                                  <SelectField
                                    id="classId"
                                    name="classId"
                                    options={
                                      match.params.business && match.params.tag
                                        ? classes &&
                                        classes
                                          ?.filter((cls) =>
                                            !values?.ageGroup ||
                                              values?.ageGroup === "all"
                                              ? true
                                              : cls?.ageGroup?.includes(
                                                values?.ageGroup
                                              )
                                          )
                                          ?.filter((cls) =>
                                            cls?.tag.includes(
                                              match.params.tag
                                            )
                                          )
                                          .map((cl) => ({
                                            label: parseEnrolmentFormClassName(
                                              cl
                                            ),
                                            value: cl._id,
                                          }))
                                        : match.params.business &&
                                          !match.params.tag &&
                                          match.url.includes("/weekly/") &&
                                          !match.url.includes(
                                            "/selected-location/"
                                          )
                                          ? classes &&
                                          classes
                                            ?.filter((cls) =>
                                              !values?.ageGroup ||
                                                values?.ageGroup === "all"
                                                ? true
                                                : cls?.ageGroup?.includes(
                                                  values?.ageGroup
                                                )
                                            )
                                            ?.filter(
                                              (cls) => !cls?.capacity_check
                                            )
                                            ?.filter((cls) =>
                                              cls?.service &&
                                                match.params.business === "ginger"
                                                ? cls?.service?.service ===
                                                "Weekly Fun Soccer"
                                                : cls?.service &&
                                                  match.params.business ===
                                                  "quest"
                                                  ? cls?.service?.service ===
                                                  "Academy Football Coaching"
                                                  : false
                                            )
                                            ?.map((cl) => ({
                                              label: parseEnrolmentFormClassName(
                                                cl
                                              ),
                                              value: cl._id,
                                            }))
                                          : match.params.business &&
                                            match.params.business === "ginger" &&
                                            !match.params.tag &&
                                            match.url.includes("/weekly/")
                                            ? classes?.map((cl) => ({
                                              label: parseEnrolmentFormClassName(
                                                cl
                                              ),
                                              value: cl._id,
                                            }))
                                            : classes &&
                                            classes
                                              ?.filter((cls) =>
                                                !values?.ageGroup ||
                                                  values?.ageGroup === "all"
                                                  ? true
                                                  : cls?.ageGroup?.includes(
                                                    values?.ageGroup
                                                  )
                                              )
                                              ?.map((cl) => ({
                                                label: parseEnrolmentFormClassName(
                                                  cl
                                                ),
                                                value: cl._id,
                                              }))
                                    }
                                    value={values && values.classId}
                                    isMulti={false}
                                    onChange={(name, value) => {
                                      setClasses(value);

                                      const selectedClass = selectedClassHelper(
                                        {
                                          classId: value.value,
                                          classes,
                                        }
                                      );

                                      if (selectedClass) {
                                        console.log({ selectedClass });

                                        if (
                                          selectedClass?.payment?.includes(
                                            "fixed"
                                          ) ||
                                          selectedClass?.paymentType === "free"
                                        ) {
                                          const termOptions = renderTerms(
                                            terms
                                          );

                                          setSelected(
                                            parseLessonsNames({
                                              classId: value.value,
                                              classes,
                                              nextTerm: values?.term === "next",
                                              term:
                                                values?.term === "next"
                                                  ? termOptions?.find(
                                                    (term) =>
                                                      term?.value ===
                                                      values?.term
                                                  )
                                                  : term,
                                              paymentOption: "full",
                                              terms,
                                            })?.sessions?.map((session) => ({
                                              value: session?._id,
                                              label: session?.date,
                                              isMatchDay: session?.matchDay,
                                            }))
                                          );
                                          setFieldValue(
                                            "paymentOption",
                                            "full"
                                          );
                                        } else if (
                                          selectedClass?.payment?.includes(
                                            "term"
                                          )
                                        ) {
                                          const termOptions = renderTerms(
                                            terms
                                          );
                                          setSelected(
                                            parseLessonsNames({
                                              nextTerm: values?.term === "next",
                                              term:
                                                values?.term === "next"
                                                  ? termOptions?.find(
                                                    (term) =>
                                                      term?.value ===
                                                      values?.term
                                                  )
                                                  : term,
                                              paymentOption: "term",
                                              classId: value.value,
                                              classes,
                                              terms,
                                            })?.sessions?.map((session) => ({
                                              value: session?._id,
                                              label: session?.date,
                                              isMatchDay: session?.matchDay,
                                            }))
                                          );
                                          setFieldValue(
                                            "paymentOption",
                                            "term"
                                          );
                                        } else if (
                                          selectedClass?.payment?.includes(
                                            "monthly"
                                          )
                                        ) {
                                          setSelected(
                                            parseLessonsNames({
                                              classId: value.value,
                                              classes,
                                              term,
                                              paymentOption: "monthly",
                                              terms,
                                            })?.sessions?.map((session) => ({
                                              value: session?._id,
                                              label: session?.date,
                                              isMatchDay: session?.matchDay,
                                            }))
                                          );
                                          setFieldValue(
                                            "paymentOption",
                                            "monthly"
                                          );
                                        }
                                      } else {
                                        setFieldValue("paymentOption", "");
                                      }

                                      if (
                                        match.params.business === "quest" &&
                                        match.url.includes("/weekly/") &&
                                        values.attendedQuest === "no" &&
                                        values.childs.every(
                                          (child) =>
                                            !child.quantity && !child.size
                                        )
                                      ) {
                                        setFieldValue(
                                          "isSizeQuantityRequired",
                                          true
                                        );
                                      }

                                      if (
                                        selectedClassHelper({
                                          classId: values?.classId?.value,
                                          classes,
                                        }).paymentType === "paid" &&
                                        !isClassFullHelper(
                                          selectedClassHelper({
                                            classId: values?.classId?.value,
                                            classes,
                                          })
                                        )
                                      ) {
                                        setFieldValue(
                                          "paymentOptionValidation",
                                          true
                                        );
                                      }

                                      setFieldValue(name, value);
                                    }}
                                    onBlur={setFieldTouched}
                                    touched={touched.classId}
                                    error={errors.classId}
                                    isClearable={true}
                                    backspaceRemovesValue={true}
                                  />
                                )}{" "}
                              </>
                            </div>
                          </div>
                        </div>
                      </>
                    )}

                    {!isClassFullHelper(
                      selectedClassHelper({
                        classId: values?.classId?.value,
                        classes,
                      })
                      ) && classes && classes.length && classes?.find((cls) => cls?._id === values?.classId?.value)
                      ?.service?.capacity_check &&
                      renderCapacityCheckText(
                        classes?.find(
                          (cls) => cls?._id === values?.classId?.value
                        )
                      ) ? (
                      <div class="alert alert-secondary" role="alert">
                        <strong>
                          {renderCapacityCheckText(
                            classes?.find(
                              (cls) => cls?._id === values?.classId?.value
                            )
                          )}
                        </strong>
                      </div>
                    ) : null}

                    {values?.classId?.value &&
                      selectedClassHelper({
                        classId: values?.classId?.value,
                        classes,
                      })?.paymentType === "free" &&
                      selectedClassHelper({
                        classId: values?.classId?.value,
                        classes,
                      })?.allow_individual_date_bookings &&
                      !isClassFullHelper(
                        selectedClassHelper({
                          classId: values?.classId?.value,
                          classes,
                        })
                      ) && (
                        <div className="row">
                          <div className="col-md-12 col-sm-12">
                            <MutiSelectableField
                              label="Select Date/Venue"
                              options={parseLessonsNames({
                                classId: values?.classId?.value,
                                classes,
                                term,
                                paymentOption: values?.paymentOption,
                                terms,
                              })?.sessions?.map((session) => ({
                                value: session?._id,
                                label: renderLessonVenueName({
                                  lesson: session,
                                  selectedClass: classes?.find(
                                    (cls) => cls?._id === values?.classId?.value
                                  ),
                                }),
                              }))}
                              selectAllLabel="All"
                              setSelected={setSelected}
                              selected={selected}
                              filterOptions={filterOptions}
                            />
                            <br />
                          </div>
                        </div>
                      )}

                    {isClassFullHelper(
                      selectedClassHelper({
                        classId: values?.classId?.value,
                        classes,
                      })
                    ) && (
                        <div class="alert alert-secondary" role="alert">
                          Class{" "}
                          <strong>
                            {
                              selectedClassHelper({
                                classId: values?.classId?.value,
                                classes,
                              })?.name
                            }
                          </strong>{" "}
                          is full, we will add you to waiting list when the form
                          is submitted.
                        </div>
                      )}

                    <p className="text-muted font-weight-bold">Child Details</p>

                    {parent && (
                      <div className="row">
                        <div className="col-sm-12 col-md-6">
                          <div className="form-group">
                            <>
                              <label>Select Children</label>
                              <SelectField
                                id="studentIds"
                                name="studentIds"
                                options={
                                  students &&
                                  students?.map((student) => ({
                                    label:
                                      student?.firstName +
                                      " " +
                                      student?.lastName,
                                    value: student?._id,
                                  }))
                                }
                                value={values && values?.studentIds}
                                isMulti={true}
                                onChange={setFieldValue}
                                onBlur={setFieldTouched}
                                touched={touched?.studentIds}
                                error={errors?.studentIds}
                                isClearable={true}
                                backspaceRemovesValue={true}
                              />
                            </>
                          </div>
                        </div>
                      </div>
                    )}
                    <FieldArray
                      name="childs"
                      render={(arrayHelpers) => (
                        <>
                          {values &&
                            values?.childs !== undefined &&
                            Array.isArray(values?.childs) &&
                            values?.childs?.length > 0 &&
                            values?.childs?.map((student, index) => (
                              <div key={index}>
                                <div className="row mt-4">
                                  <div className="col-md-8 mt-2">
                                    <h5>
                                      {index > 0
                                        ? `Child ${index + 1}`
                                        : "Child 1"}
                                    </h5>
                                  </div>
                                  <div className="col-md-4">
                                    {(!parent && index > 0) || parent ? (
                                      <div style={{ textAlign: "right" }}>
                                        <div
                                          class="btn-group"
                                          role="group"
                                          aria-label="First group"
                                        >
                                          <button
                                            type="button"
                                            class="btn btn-primary  btn-icon"
                                            onClick={() =>
                                              arrayHelpers.insert(index, {
                                                ...CHILD_FIELDS,
                                                isSizeAndQuantityRequired:
                                                  match.params.business ===
                                                    "quest" &&
                                                    match.url.includes("/weekly/")
                                                    ? true
                                                    : false,
                                              })
                                            }
                                            style={{ fontSize: 16 }}
                                          >
                                            <strong>+</strong>
                                          </button>
                                          <button
                                            type="button"
                                            class="btn btn-success btn-icon"
                                            onClick={() =>
                                              arrayHelpers.remove(index)
                                            }
                                            style={{ fontSize: 16 }}
                                          >
                                            <strong>-</strong>
                                          </button>
                                        </div>
                                      </div>
                                    ) : null}
                                  </div>
                                </div>

                                {/* {((!parent && index > 0) || parent) && (
                                  <div className="row">
                                    <div className="col-sm-12 col-md-6">
                                      <div className="form-group">
                                        <>
                                          <label>Select Class</label>
                                          <SelectField
                                            id="childClassIds"
                                            name={`childs.[${index}].childClassIds`}
                                            options={
                                              match.params.business &&
                                              !match.params.tag &&
                                              match.url.includes("weekly")
                                                ? classes &&
                                                  classes
                                                    ?.filter(
                                                      (cls) =>
                                                        cls?.tag ===
                                                        match.params.tag
                                                    )
                                                    .map((cl) => ({
                                                      label: parseEnrolmentFormClassName(
                                                        cl
                                                      ),
                                                      value: cl._id,
                                                    }))
                                                : match.params.business &&
                                                  !match.params.tag &&
                                                  match.url.includes(
                                                    "/weekly/"
                                                  ) &&
                                                  !match.url.includes(
                                                    "/selected-location/"
                                                  )
                                                ? classes &&
                                                  classes
                                                    ?.filter(
                                                      (cls) =>
                                                        cls?.tag === "Weekly"
                                                    )
                                                    .map((cl) => ({
                                                      label: parseEnrolmentFormClassName(
                                                        cl
                                                      ),
                                                      value: cl._id,
                                                    }))
                                                : classes &&
                                                  classes?.map((cl) => ({
                                                    label: parseEnrolmentFormClassName(
                                                      cl
                                                    ),
                                                    value: cl._id,
                                                  }))
                                            }
                                            value={
                                              values.childs[index]
                                                .childClassIds &&
                                              values.childs[index].childClassIds
                                                .length > 0
                                                ? values.childs[index]
                                                    .childClassIds
                                                : selectedClasses || []
                                            }
                                            isMulti={true}
                                            onChange={(name, value) => {
                                              if (value === null) {
                                                setClasses([]);
                                              }
                                              setFieldValue(name, value);
                                            }}
                                            onBlur={setFieldTouched}
                                            touched={touched.childClassIds}
                                            error={errors.childClassIds}
                                            isClearable={true}
                                            backspaceRemovesValue={true}
                                          />
                                        </>
                                      </div>
                                    </div>
                                  </div>
                                )} */}

                                <div className="row">
                                  <div className="col-sm-12 col-md-6">
                                    {" "}
                                    <div className="form-group">
                                      <Field
                                        type="text"
                                        name={`childs.[${index}].childFirstName`}
                                        component={Input}
                                      >
                                        {({ field, form, meta }) => (
                                          <div>
                                            <label htmlFor="childFirstName">
                                              Child's First Name
                                            </label>
                                            <input
                                              type="text"
                                              {...field}
                                              className={`${getInputClasses(
                                                meta
                                              )}`}
                                              id="childFirstName"
                                            />
                                            {meta.touched && meta.error && (
                                              <div className="error invalid-feedback">
                                                {meta.error}
                                              </div>
                                            )}
                                          </div>
                                        )}
                                      </Field>
                                    </div>
                                  </div>
                                  <div className="col-sm-12 col-md-6">
                                    {" "}
                                    <div className="form-group">
                                      <Field
                                        type="text"
                                        name={`childs.[${index}].childLastName`}
                                        component={Input}
                                      >
                                        {({ field, form, meta }) => (
                                          <div>
                                            <label htmlFor="childLastName">
                                              Child's Last Name
                                            </label>
                                            <input
                                              type="text"
                                              {...field}
                                              className={`${getInputClasses(
                                                meta
                                              )} form-control`}
                                              id="childLastName"
                                            />
                                            {meta.touched && meta.error && (
                                              <div className="error invalid-feedback">
                                                {meta.error}
                                              </div>
                                            )}
                                          </div>
                                        )}
                                      </Field>
                                    </div>
                                  </div>
                                  <div className="col-sm-12 col-md-6">
                                    <div className="form-group">
                                      <label htmlFor="childLastName">
                                        Child's DOB
                                      </label>

                                      <Field
                                        name={`childs.[${index}].childDOB`}
                                        render={({ field, form, meta }) => (
                                          <>
                                            <TextField
                                              style={{ marginLeft: 0 }}
                                              id="to"
                                              {...field}
                                              type="date"
                                              className={styleClasses.textField}
                                              InputLabelProps={{
                                                shrink: true,
                                              }}
                                              variant="outlined"
                                              size="small"
                                            />
                                            {meta.touched && meta.error && (
                                              <span
                                                style={{
                                                  color: "#F64E60",
                                                  fontWeight: 400,
                                                  fontSize: 12,
                                                }}
                                              >
                                                {meta.error}
                                              </span>
                                            )}
                                          </>
                                        )}
                                      ></Field>
                                    </div>
                                  </div>
                                  <div className="col-sm-12 col-md-6">
                                    <div className="form-group">
                                      <label id="my-radio-group">Gender</label>
                                      <br />
                                      {genderOptions.map((condition) => (
                                        <div
                                          key={condition.value}
                                          role="group"
                                          className="form-check form-check-inline mr-2"
                                          aria-labelledby="my-radio-group"
                                        >
                                          <label>
                                            <Field
                                              type="radio"
                                              name={`childs.[${index}].gender`}
                                              value={condition.value}
                                            />{" "}
                                            {condition.text}
                                          </label>
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                </div>

                                <div className="row">
                                  <div className="col-sm-12 col-md-12">
                                    {" "}
                                    <div className="form-group">
                                      <Field
                                        type="text"
                                        name={`childs.[${index}].medicalConditionDetails`}
                                        component={Input}
                                      >
                                        {({ field, form, meta }) => (
                                          <div>
                                            <label htmlFor="medicalConditionDetails">
                                              Please specify any additional
                                              information it may be important
                                              for us to know, ie medical issues,
                                              etc
                                            </label>
                                            <input
                                              type="text"
                                              {...field}
                                              className={`${getInputClasses(
                                                meta
                                              )}`}
                                              id="medicalConditionDetails"
                                            />
                                            {meta.touched && meta.error && (
                                              <div className="error invalid-feedback">
                                                {meta.error}
                                              </div>
                                            )}
                                          </div>
                                        )}
                                      </Field>
                                    </div>
                                  </div>

                                  <div className="col-sm-12 col-md-6">
                                    <div className="form-group">
                                      <label id="my-radio-group">
                                        Photo/Video Permission
                                      </label>
                                      <br />
                                      {photoVideoPermissionOptions.map(
                                        (condition) => (
                                          <div
                                            key={condition.value}
                                            role="group"
                                            className="form-check form-check-inline mr-2"
                                            aria-labelledby="my-radio-group"
                                          >
                                            <label>
                                              <Field
                                                type="radio"
                                                name={`childs.[${index}].photoVideoPermission`}
                                                value={condition.value}
                                              />{" "}
                                              {condition.text}
                                            </label>
                                          </div>
                                        )
                                      )}
                                    </div>
                                  </div>

                                  {!isClassFullHelper (
                                    selectedClassHelper({
                                      classId: values?.classId?.value,
                                      classes,
                                    })
                                  ) && (
                                      <>
                                        {values.isQuestWeekly &&
                                          selectedClassHelper({
                                            classId: values?.classId?.value,
                                            classes,
                                          })?.product?._id &&
                                          selectedClassHelper({
                                            classId: values?.classId?.value,
                                            classes,
                                          })?.include_kit ? (
                                          <>
                                            <div className="col-sm-12 col-md-12">
                                              <div className="form-group">
                                                <label id="my-radio-group">
                                                  Would you like to kit your little soccer-star out in our super-cool merchandise? Price is {" "}
                                                  {"$" +
                                                    selectedClassHelper({
                                                      classId:
                                                        values?.classId?.value,
                                                      classes,
                                                    })?.product?.price}{" "}
                                                  with free delivery.
                                                </label>
                                                <br />
                                                {photoVideoPermissionOptions.map(
                                                  (condition) => (
                                                    <div
                                                      key={condition.value}
                                                      role="group"
                                                      className="form-check form-check-inline mr-2"
                                                      aria-labelledby="my-radio-group"
                                                    >
                                                      <label>
                                                        <Field
                                                          type="radio"
                                                          name={`childs.[${index}].attendedQuest`}
                                                          value={condition.value}
                                                        />{" "}
                                                        {condition.text}
                                                      </label>
                                                    </div>
                                                  )
                                                )}
                                              </div>
                                            </div>
                                            {/* {values.childs[index]
                                              .attendedQuest === "no" && (
                                                <div className="col-sm-12 col-md-12">
                                                  <p>
                                                    New Players are asked to
                                                    Purchase a mandatory uniform(
                                                    {"$" +
                                                      selectedClassHelper({
                                                        classId:
                                                          values?.classId?.value,
                                                        classes,
                                                      })?.product?.price}
                                                    ). Please select size below.
                                                  </p>
                                                </div>
                                              )} */}
                                          </>
                                        ) : null}

                                        {classes &&
                                          selectedClassHelper({
                                            classId: values?.classId?.value,
                                            classes,
                                          })?.include_kit &&
                                          selectedClassHelper({
                                            classId: values?.classId?.value,
                                            classes,
                                          })?.product?._id &&
                                          selectedClassHelper({
                                            classId: values?.classId?.value,
                                            classes,
                                          })?.kit_mandatory &&
                                          !values.isQuestWeekly ? (
                                          <>
                                          
                                            {
                                              attendedQuest(values.childs, index)
                                            }
                                          
                                            <div className="col-sm-12 col-md-12">
                                            {/*   <div className="form-group">
                                                <label id="my-radio-group">
                                                  Have you previously attended
                                                  this program?
                                                </label>
                                                <br />
                                                {photoVideoPermissionOptions.map(
                                                  (condition) => (
                                                    <div
                                                      key={condition.value}
                                                      role="group"
                                                      className="form-check form-check-inline mr-2"
                                                      aria-labelledby="my-radio-group"
                                                    >
                                                      <label>
                                                        <Field
                                                          type="radio"
                                                          name={`childs.[${index}].attendedQuest`}
                                                          value={condition.value}
                                                        />{" "}
                                                        {condition.text}
                                                      </label>
                                                    </div>
                                                  )
                                                )}
                                              </div> */}
                                            </div> 
                                            {values.childs[index]
                                              .attendedQuest === "no" && (
                                                <div className="col-sm-12 col-md-12">
                                                  <p>
                                                    New Players are asked to
                                                    Purchase a mandatory uniform(
                                                    {"$" +
                                                      selectedClassHelper({
                                                        classId:
                                                          values?.classId?.value,
                                                        classes,
                                                      })?.product?.price}
                                                    ). Please select size below.
                                                  </p>
                                                </div>
                                              )}
                                          </>
                                        ) : null}

                                        {classes &&
                                          selectedClassHelper({
                                            classId: values?.classId?.value,
                                            classes,
                                          })?.include_kit &&
                                          selectedClassHelper({
                                            classId: values?.classId?.value,
                                            classes,
                                          })?.product?._id &&
                                          !selectedClassHelper({
                                            classId: values?.classId?.value,
                                            classes,
                                          })?.kit_mandatory &&
                                          !values.isQuestWeekly && (
                                            <div className="col-sm-12 col-md-12">
                                              <div className="form-group">
                                                <label id="my-radio-group">
                                                  Would you like to kit your
                                                  little soccer-star out in our
                                                  super-cool merchandise? Price is
                                                  $
                                                  {
                                                    selectedClassHelper({
                                                      classId:
                                                        values?.classId?.value,
                                                      classes,
                                                    })?.product?.price
                                                  }{" "}
                                                  with free delivery.
                                                </label>
                                                <br />
                                                {merchandiseOptions.map(
                                                  (merchandise) => (
                                                    <div
                                                      key={merchandise.value}
                                                      role="group"
                                                      className="form-check form-check-inline mr-2"
                                                      aria-labelledby="my-radio-group"
                                                    >
                                                      <label>
                                                        <Field
                                                          type="radio"
                                                          name={`childs.[${index}].merchandise`}
                                                          value={
                                                            merchandise.value
                                                          }
                                                        />{" "}
                                                        {merchandise.text}
                                                      </label>
                                                    </div>
                                                  )
                                                )}
                                              </div>
                                            </div>
                                          )}

                                        {(classes &&
                                          !values.isQuestWeekly &&
                                          values.childs[index].merchandise ===
                                          "yes" &&
                                          selectedClassHelper({
                                            classId: values?.classId?.value,
                                            classes,
                                          })?.include_kit &&
                                          selectedClassHelper({
                                            classId: values?.classId?.value,
                                            classes,
                                          })?.product?._id &&
                                          !selectedClassHelper({
                                            classId: values?.classId?.value,
                                            classes,
                                          })?.kit_mandatory) ||
                                          (values.childs[index].attendedQuest ===
                                            "yes" &&
                                            selectedClassHelper({
                                              classId: values?.classId?.value,
                                              classes,
                                            })?.include_kit &&
                                            selectedClassHelper({
                                              classId: values?.classId?.value,
                                              classes,
                                            })?.product?._id &&
                                            values.isQuestWeekly) ||
                                          (values.childs[index].attendedQuest ===
                                            "yes" &&
                                            classes &&
                                            selectedClassHelper({
                                              classId: values?.classId?.value,
                                              classes,
                                            })?.include_kit &&
                                            selectedClassHelper({
                                              classId: values?.classId?.value,
                                              classes,
                                            })?.product?._id &&
                                            selectedClassHelper({
                                              classId: values?.classId?.value,
                                              classes,
                                            })?.kit_mandatory &&
                                            !values.isQuestWeekly) ? (
                                          <div className="col-md-6 col-sm-12 mt-2 mb-2">
                                            <div className="row">
                                              <div className="col-md-8">
                                                {/* <img
                                                src={
                                                  selectedClassHelper({
                                                    classId:
                                                      values?.classId?.value,
                                                    classes,
                                                  })?.product?.featureImage
                                                }
                                                style={{
                                                  height: 150,
                                                  width: 150,
                                                }}
                                              /> */}

                                                {selectedClassHelper({
                                                  classId: values?.classId?.value,
                                                  classes,
                                                })?.include_kit &&
                                                  (selectedClassHelper({
                                                    classId:
                                                      values?.classId?.value,
                                                    classes,
                                                  })?.product?.additionalImages
                                                    ? [
                                                      selectedClassHelper({
                                                        classId:
                                                          values?.classId
                                                            ?.value,
                                                        classes,
                                                      })?.product?.featureImage,
                                                      ...selectedClassHelper({
                                                        classId:
                                                          values?.classId
                                                            ?.value,
                                                        classes,
                                                      })?.product
                                                        ?.additionalImages,
                                                    ]
                                                    : selectedClassHelper({
                                                      classId:
                                                        values?.classId?.value,
                                                      classes,
                                                    })?.include_kit && [
                                                      selectedClassHelper({
                                                        classId:
                                                          values?.classId
                                                            ?.value,
                                                        classes,
                                                      })?.product?.featureImage,
                                                    ]
                                                  )?.map((imageUrl) => (
                                                    <span
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                    >
                                                      <Zoom>
                                                        <img
                                                          // onClick={() => {
                                                          //   setLgShow(true);
                                                          //   setImageUrls(imageUrl);
                                                          // }}
                                                          className="ml-2"
                                                          src={imageUrl}
                                                          style={{
                                                            height: 150,
                                                            width: 150,
                                                          }}
                                                        />
                                                      </Zoom>
                                                    </span>
                                                  ))}
                                              </div>
                                              <div className="col-md-4">
                                                <div className="row">
                                                  <div className="col-md-12">
                                                    <Field
                                                      name={`childs.[${index}].size`}
                                                      component={Select}
                                                      validate={() =>
                                                        validateSize(
                                                          values,
                                                          classes,
                                                          index
                                                        )
                                                      }
                                                    >
                                                      {({
                                                        field,
                                                        form,
                                                        meta,
                                                      }) => (
                                                        <>
                                                          <label>Size</label>
                                                          <select
                                                            {...field}
                                                            name={`childs.[${index}].size`}
                                                            className={`form-control`}
                                                            id="size"
                                                            style={{
                                                              border:
                                                                meta.touched &&
                                                                  meta.error
                                                                  ? "red 1px solid"
                                                                  : "",
                                                              width: "60%",
                                                            }}
                                                          >
                                                            <option value="">
                                                              Select
                                                            </option>
                                                            {selectedClassHelper({
                                                              classId:
                                                                values?.classId
                                                                  ?.value,
                                                              classes,
                                                            })?.product
                                                              ?.attributes &&
                                                              selectedClassHelper(
                                                                {
                                                                  classId:
                                                                    values
                                                                      ?.classId
                                                                      ?.value,
                                                                  classes,
                                                                }
                                                              )?.product?.attributes.map(
                                                                (attribute) => {
                                                                  return (
                                                                    <option
                                                                      key={
                                                                        attribute.label
                                                                      }
                                                                      value={
                                                                        attribute.label
                                                                      }
                                                                    >
                                                                      {
                                                                        attribute.label
                                                                      }
                                                                    </option>
                                                                  );
                                                                }
                                                              )}
                                                          </select>
                                                          {meta.touched &&
                                                            meta.error && (
                                                              <div
                                                                className="error "
                                                                style={{
                                                                  color: "red",
                                                                }}
                                                              >
                                                                {meta.error}
                                                              </div>
                                                            )}
                                                        </>
                                                      )}
                                                    </Field>
                                                  </div>
                                                </div>

                                                <div className="row mt-2">
                                                  <div className="col-md-12">
                                                    <Field
                                                      type="number"
                                                      name={`childs.[${index}].quantity`}
                                                      component={Input}
                                                      validate={() =>
                                                        validateQuantity(
                                                          values,
                                                          classes,
                                                          index
                                                        )
                                                      }
                                                    >
                                                      {({
                                                        field,
                                                        form,
                                                        meta,
                                                      }) => (
                                                        <div>
                                                          <label htmlFor="parentFirstName">
                                                            Quantity
                                                          </label>
                                                          <input
                                                            type="number"
                                                            name={`childs.[${index}].quantity`}
                                                            {...field}
                                                            className={`form-control`}
                                                            id="quantity"
                                                            style={{
                                                              border:
                                                                meta.touched &&
                                                                  meta.error
                                                                  ? "red 1px solid"
                                                                  : "",
                                                              width: "60%",
                                                            }}
                                                            min="0"
                                                            onChange={(e) => {
                                                              e.preventDefault();
                                                              const {
                                                                value,
                                                              } = e.target;
                                                              const regex = /^(0*[0-9][0-9]*(\.[0-9]*)?|0*\.[0-9]*[1-9][0-9]*)$/;
                                                              console.log(
                                                                regex.test(
                                                                  value.toString()
                                                                )
                                                              );
                                                              if (
                                                                !value ||
                                                                regex.test(
                                                                  value.toString()
                                                                )
                                                              ) {
                                                                setFieldValue(
                                                                  `childs.[${index}].quantity`,
                                                                  parseInt(value)
                                                                );
                                                              }
                                                            }}
                                                          />
                                                          {meta.touched &&
                                                            meta.error && (
                                                              <div
                                                                className="error "
                                                                style={{
                                                                  color: "red",
                                                                }}
                                                              >
                                                                {meta.error}
                                                              </div>
                                                            )}
                                                        </div>
                                                      )}
                                                    </Field>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            {/* ))} */}

                                                                                {selectedClassHelper({
                                    classId: values?.classId?.value,
                                    classes,
                                    })?.product?.personalisationAvailable ?                                       
                                      <div className="col-md-12 col-sm-12 mt-2 mb-2">
                                              <Field
                                                type="text"
                                                name={`childs.[${index}].personalisationDetails`}
                                                component={Input}
                                              >
                                                {({ field, form, meta }) => (
                                                  <div>
                                                    <label htmlFor="personalisationDetails">
                                                      Personalisation Details
                                                    </label>
                                                    <input
                                                      type="text"
                                                      name={`childs.[${index}].personalisationDetails`}
                                                      {...field}
                                                      className={`form-control`}
                                                      id="personalisationDetails"
                                                      style={{
                                                        border:
                                                          meta.touched &&
                                                          meta.error
                                                            ? "red 1px solid"
                                                            : "",
                                                        width: "60%",
                                                      }}
                                                      onChange={(e) => {
                                                          setFieldValue(`childs.[${index}].personalisationDetails`, e.target.value );
                                                      }}
                                                    />
                                                    {meta.touched && meta.error && (
                                                      <div
                                                        className="error "
                                                        style={{
                                                          color: "red",
                                                        }}
                                                      >
                                                        {meta.error}
                                                      </div>
                                                    )}
                                                  </div>
                                                )}
                                              </Field>
                                    </div> : null}
                                          </div>
                                        ) : null}
                                      </>
                                    )}
                                </div>
                              </div>
                            ))}
                          {((!parent && values?.childs?.length === 1) ||
                            (parent && values?.childs?.length === 0)) && (
                              <div style={{ textAlign: "right" }}>
                                {selectedClassHelper({
                                  classId: values?.classId?.value,
                                  classes,
                                })?.additional_child_discount ? (
                                  <p className="text-muted font-weight-bold">
                                    Get{" "}
                                    {
                                      selectedClassHelper({
                                        classId: values?.classId?.value,
                                        classes,
                                      })?.additional_child_discount
                                    }
                                    % discount for the additional child.{" "}
                                  </p>
                                ) : null}
                                <button
                                  className="btn btn-success"
                                  onClick={() =>
                                    arrayHelpers.push({
                                      ...CHILD_FIELDS,
                                      isSizeAndQuantityRequired:
                                        match.params.business === "quest" &&
                                          match.url.includes("/weekly/")
                                          ? true
                                          : false,
                                    })
                                  }
                                >
                                  Add additional child
                                </button>
                              </div>
                            )}
                        </>
                      )}
                    />
                    <p className="text-muted font-weight-bold mt-4">
                      Parent/Guardian Details
                    </p>
                    <div className="row">
                      <div className="col-sm-12 col-md-6">
                        {" "}
                        <div className="form-group">
                          <Field
                            type="text"
                            name="parentFirstName"
                            component={Input}
                          >
                            {({ field, form, meta }) => (
                              <div>
                                <label htmlFor="parentFirstName">
                                  Parent/Guardian First Name
                                </label>
                                <input
                                  type="text"
                                  {...field}
                                  className={`${getInputClasses(meta)}`}
                                  id="parentFirstName"
                                />
                                {meta.touched && meta.error && (
                                  <div className="error invalid-feedback">
                                    {meta.error}
                                  </div>
                                )}
                              </div>
                            )}
                          </Field>
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-6">
                        <div className="form-group">
                          <Field
                            type="text"
                            name="parentLastName"
                            component={Input}
                          >
                            {({ field, form, meta }) => (
                              <div>
                                <label htmlFor="parentLastName">
                                  Parent/Guardian Last Name
                                </label>
                                <input
                                  type="text"
                                  {...field}
                                  className={`${getInputClasses(meta)}`}
                                  id="parentLastName"
                                />
                                {meta.touched && meta.error && (
                                  <div className="error invalid-feedback">
                                    {meta.error}
                                  </div>
                                )}
                              </div>
                            )}
                          </Field>
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-6">
                        <div className="form-group">
                          <Field
                            type="number"
                            name="parentPhone"
                            component={Input}
                          >
                            {({ field, form, meta }) => (
                              <div>
                                <label htmlFor="parentPhone">
                                  Parent/Guardian Phone Number
                                </label>
                                <input
                                  type="number"
                                  {...field}
                                  className={`${getInputClasses(meta)}`}
                                  id="parentPhone"
                                />
                                {meta.touched && meta.error && (
                                  <div className="error invalid-feedback">
                                    {meta.error}
                                  </div>
                                )}
                              </div>
                            )}
                          </Field>
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-6">
                        <div className="form-group">
                          <Field
                            type="email"
                            name="parentEmail"
                            component={Input}
                          >
                            {({ field, form, meta }) => (
                              <div>
                                <label htmlFor="parentEmail">
                                  Parent/Guardian Email{" "}
                                </label>
                                <input
                                  type="email"
                                  {...field}
                                  className="form-control"
                                  id="parentEmail"
                                  style={{
                                    border:
                                      ((meta.touched && meta.error) || error) &&
                                      "1px red solid",
                                  }}
                                  onChange={(e) => {
                                    onChangeHandler(e);

                                    setFieldValue(
                                      "parentEmail",
                                      e.target.value.toLowerCase()
                                    );
                                  }}
                                  disabled={
                                    user?.roleId?.name === "parent" &&
                                    user?.business === match?.params?.business
                                  }
                                />
                                {user?.roleId?.name === "parent" &&
                                  user?.business ===
                                  match?.params?.business ? null : (
                                  <>
                                    {message && (
                                      <div
                                        style={{
                                          color: error ? "red" : "green",
                                        }}
                                      >
                                        {exist ? (
                                          <p>
                                            An account already exist with this
                                            email address. Please{" "}
                                            <span
                                              style={{
                                                cursor: "pointer",
                                                color: "blue",
                                              }}
                                              onClick={showModal}
                                              href="javascript:void(0)"
                                            >
                                              login
                                            </span>{" "}
                                            to checkout.
                                          </p>
                                        ) : null}
                                      </div>
                                    )}
                                  </>
                                )}
                              </div>
                            )}
                          </Field>
                        </div>
                      </div>
                    </div>

                    {/*<p className="text-muted font-weight-bold">*/}
                    {/*  If you have ordered any merchandise, we will deliver your*/}
                    {/*  items to this address via courier, no PO Boxes please*/}
                    {/*</p>*/}
                    <div className="row">
                      <div className="col-sm-12 col-md-6">
                        <div className="form-group">
                          <Field type="text" name="address" component={Input}>
                            {({ field, form, meta }) => (
                              <div>
                                <label htmlFor="parentLastName">Address</label>
                                <input
                                  type="text"
                                  {...field}
                                  className={`${getInputClasses(meta)}`}
                                  id="address"
                                />
                                {meta.touched && meta.error && (
                                  <div className="error invalid-feedback">
                                    {meta.error}
                                  </div>
                                )}
                              </div>
                            )}
                          </Field>
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-6">
                        <div className="form-group">
                          <Field type="text" name="suburb" component={Input}>
                            {({ field, form, meta }) => (
                              <div>
                                <label htmlFor="parentLastName">Suburb</label>
                                <input
                                  type="text"
                                  {...field}
                                  className={`${getInputClasses(meta)}`}
                                  id="suburb"
                                />
                                {meta.touched && meta.error && (
                                  <div className="error invalid-feedback">
                                    {meta.error}
                                  </div>
                                )}
                              </div>
                            )}
                          </Field>
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-6">
                        <div className="form-group">
                          <Field type="text" name="postcode" component={Input}>
                            {({ field, form, meta }) => (
                              <div>
                                <label htmlFor="parentLastName">Postcode</label>
                                <input
                                  type="text"
                                  {...field}
                                  className={`${getInputClasses(meta)}`}
                                  id="postcode"
                                />
                                {meta.touched && meta.error && (
                                  <div className="error invalid-feedback">
                                    {meta.error}
                                  </div>
                                )}
                              </div>
                            )}
                          </Field>
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-6">
                        <div className="form-group">
                          <Field type="text" name="state" component={Input}>
                            {({ field, form, meta }) => (
                              <div>
                                <label htmlFor="state">State</label>
                                <input
                                  type="text"
                                  {...field}
                                  className={`${getInputClasses(meta)}`}
                                  id="state"
                                />
                                {meta.touched && meta.error && (
                                  <div className="error invalid-feedback">
                                    {meta.error}
                                  </div>
                                )}
                              </div>
                            )}
                          </Field>
                        </div>
                      </div>
                    </div>

                    <div className="form-group">
                    <Field name="hearAboutUs" component={Input}>
                      {({ field, form, meta }) => (
                        <>
                          <label>How did you hear about us</label>
                          <select
                            name="hearAboutUs"
                            {...field}
                            className={`${getInputClasses(meta)}`}
                            id="hearAboutUs"
                            style={{
                              border:
                                meta.touched && meta.error ? "red 1px solid" : "",
                              width: "100%",
                            }}
                            onChange={(e) => {
                              setFieldValue(
                                "hearAboutUs",
                                e.target.value
                              );
                              setFieldValue(
                                "referralAndOther",
                                e.target.value == "referral" || e.target.value == "other" ? "" : e.target.value
                              );
                            }}
                          >
                            <option value="">Select</option>
                            {hearAboutUsOptions.map((hearAboutUsOption) => {
                              return (
                                <option value={hearAboutUsOption.value}>
                                  {hearAboutUsOption.text}
                                </option>
                              );
                            })}
                          </select>
                          {meta.touched && meta.error && (
                            <div className="error invalid-feedback">{meta.error}</div>
                          )}
                        </>
                      )}
                    </Field>
                  </div>
                    
                  {
                    values.hearAboutUs == "referral" || values.hearAboutUs == "other" ? (
                      <div className="form-group">
                        <Field name="referralAndOther" component={Input}>
                          {({ field, form, meta }) => (
                            <>
                              <label>Referral/Other</label>
                              <input
                                type="text"
                                {...field}
                                className={`${getInputClasses(meta)}`}
                                id="referralAndOther"
                              />
                              {meta.touched && meta.error && (
                                <div className="error invalid-feedback">{meta.error}</div>
                              )}
                            </>
                          )}
                        </Field>
                      </div>
                    )
                      : null
                  }

                    {(stripePublishableKey &&
                      selectedClassHelper({
                        classId: values?.classId?.value,
                        classes,
                      })?.paymentType === "paid") ||
                      (stripePublishableKey &&
                        priceCalculateHelper({
                          selectedClass: selectedClassHelper({
                            classId: values?.classId?.value,
                            classes,
                          }),
                          values,
                          selectedCoupon: coupon,
                          lessons: selected?.map((lesson) => lesson?.value),
                        })?.totalAmountToPay > 0) ? (
                      <>
                        <p className="text-muted font-weight-bold">
                          Payment Details
                        </p>

                        {(!isClassFullHelper(
                          selectedClassHelper({
                            classId: values?.classId?.value,
                            classes,
                          })
                        ) &&
                          match.url.includes("enrolment")) ||
                          (!isClassFullHelper(
                            selectedClassHelper({
                              classId: values?.classId?.value,
                              classes,
                            })
                          ) &&
                            selectedClassHelper({
                              classId: values?.classId?.value,
                              classes,
                            })?.paymentType === "paid") ? (
                          <div className="row">
                            <div className="col-sm-12 col-md-6">
                              <div className="form-group">
                                <Field
                                  type="text"
                                  name="coupon"
                                  component={Input}
                                >
                                  {({ field, form, meta }) => (
                                    <div>
                                      <label htmlFor="coupon">
                                        Enter Coupon Code (if you have one)
                                      </label>
                                      <input
                                        type="text"
                                        {...field}
                                        className="form-control"
                                        id="coupon"
                                        style={{
                                          border:
                                            meta.touched &&
                                            meta.error &&
                                            "1px red solid",
                                        }}
                                        onChange={(e) => {
                                          const selectedClass = selectedClassHelper(
                                            {
                                              classId: values?.classId?.value,
                                              classes,
                                            }
                                          );

                                          onCouponChangeHandler(e);

                                          field.onChange(e);
                                        }}
                                      />
                                      {couponValidateMessage && (
                                        <div
                                          style={{
                                            color:
                                              couponValidateMessage ===
                                                "Coupon Applied"
                                                ? "green"
                                                : "red",
                                          }}
                                        >
                                          <p>{couponValidateMessage}</p>
                                        </div>
                                      )}
                                    </div>
                                  )}
                                </Field>
                              </div>
                            </div>
                          </div>
                        ) : null}

                        {!isClassFullHelper(
                          selectedClassHelper({
                            classId: values?.classId?.value,
                            classes,
                          })
                        ) &&
                          selectedClassHelper({
                            classId: values?.classId?.value,
                            classes,
                          })
                            ?.payment?.map((payment) => {
                              if (payment === "fixed") {
                                return {
                                  text: "Full",
                                  value: "full",
                                };
                              } else if (payment === "monthly") {
                                return {
                                  text: "Monthly",
                                  value: "monthly",
                                };
                              } else if (payment === "term") {
                                return {
                                  text: "Term",
                                  value: "term",
                                };
                              }
                            })
                            ?.filter((method) => method !== undefined)?.length >
                          1 && (
                            <div className="row">
                              <div className="col-sm-12 col-md-12">
                                <div className="form-group">
                                  <Field
                                    type="select"
                                    name="paymentOption"
                                    component={Select}
                                    validate={() =>
                                      validatePaymentOption(values, classes)
                                    }
                                  >
                                    {({ field, form, meta }) => (
                                      <div>
                                        <label>Payment Option</label>
                                        <select
                                          {...field}
                                          className={`${getInputClasses(meta)}`}
                                          name="paymentOption"
                                          id="paymentOption"
                                          onChange={(e) => {
                                            if (
                                              values?.classId &&
                                              e.target.value
                                            ) {
                                              const termOptions = renderTerms(
                                                terms
                                              );

                                              setSelected(
                                                parseLessonsNames({
                                                  classId:
                                                    values?.classId?.value,
                                                  classes,
                                                  nextTerm:
                                                    values?.term === "next",
                                                  term:
                                                    values?.term === "next"
                                                      ? termOptions?.find(
                                                        (term) =>
                                                          term?.value ===
                                                          values?.term
                                                      )
                                                      : term,
                                                  paymentOption: e.target.value,
                                                  terms,
                                                })?.sessions?.map(
                                                  (session) => ({
                                                    value: session?._id,
                                                    label: session?.date,
                                                    isMatchDay:
                                                      session?.matchDay,
                                                  })
                                                )
                                              );
                                            }

                                            setFieldValue(
                                              "paymentOption",
                                              e.target.value
                                            );
                                          }}
                                        >
                                          <option value="">Select</option>
                                          {selectedClassHelper({
                                            classId: values?.classId?.value,
                                            classes,
                                          })
                                            ?.payment?.map((payment) => {
                                              if (payment === "fixed") {
                                                return {
                                                  text: "Full",
                                                  value: "full",
                                                };
                                              } else if (
                                                payment === "monthly"
                                              ) {
                                                return {
                                                  text: "Monthly",
                                                  value: "monthly",
                                                };
                                              } else if (payment === "term") {
                                                return {
                                                  text: "Term",
                                                  value: "term",
                                                };
                                              }
                                            })
                                            ?.filter(
                                              (method) => method !== undefined
                                            )
                                            ?.map((payment) => (
                                              <option
                                                key={payment?.value}
                                                value={payment?.value}
                                              >
                                                {payment?.text}
                                              </option>
                                            ))}
                                        </select>

                                        {meta.touched && meta.error && (
                                          <div className="error invalid-feedback">
                                            {meta.error}
                                          </div>
                                        )}
                                      </div>
                                    )}
                                  </Field>
                                </div>
                              </div>
                            </div>
                          )}

                        {values.classId &&
                          values.paymentOption &&
                          selectedClassHelper({
                            classId: values?.classId?.value,
                            classes,
                          })?.allow_individual_date_bookings &&
                          !isClassFullHelper(
                            selectedClassHelper({
                              classId: values?.classId?.value,
                              classes,
                            })
                          ) && (
                            <div className="row">
                              <div className="col-md-12 col-sm-12">
                                <MutiSelectableField
                                  label="Select Date/Venue"
                                  options={parseLessonsNames({
                                    classId: values?.classId?.value,
                                    classes,
                                    term,
                                    paymentOption: values?.paymentOption,
                                    terms,
                                  })?.sessions?.map((session) => ({
                                    value: session?._id,
                                    label: renderLessonVenueName({
                                      lesson: session,
                                      selectedClass: classes?.find(
                                        (cls) =>
                                          cls?._id === values?.classId?.value
                                      ),
                                    }),
                                  }))}
                                  selectAllLabel="All"
                                  setSelected={setSelected}
                                  selected={selected}
                                  filterOptions={filterOptions}
                                />
                                <br />
                              </div>
                            </div>
                          )}

                        {selectedClassHelper({
                          classId: values?.classId?.value,
                          classes,
                        })?.include_kit &&
                          selectedClassHelper({
                            classId: values?.classId?.value,
                            classes,
                          })?.product?.price ? (
                          (values.classId &&
                            values.paymentOption === "full" &&
                            !isClassFullHelper(
                              selectedClassHelper({
                                classId: values?.classId?.value,
                                classes,
                              })
                            )) ||
                            (values.classId &&
                              values.paymentOption === "term" &&
                              !isClassFullHelper(
                                selectedClassHelper({
                                  classId: values?.classId?.value,
                                  classes,
                                })
                              )) ? (
                            <>
                              <h5>
                                <strong style={{ fontSize: "15px" }}>
                                  Price:
                                </strong>
                              </h5>{" "}
                              <span style={{ fontSize: "15px" }}>
                                {values?.term === "next" &&
                                  values?.paymentOption === "term" ? (
                                  <>
                                    <div>
                                      <strong>Kit:</strong>
                                      {"$" +
                                        priceCalculateHelper({
                                          selectedClass: selectedClassHelper({
                                            classId: values?.classId?.value,
                                            classes,
                                          }),
                                          values,
                                          selectedCoupon: coupon,
                                          lessons: selected?.map(
                                            (lesson) => lesson?.value
                                          ),
                                        })?.totalOrderAmount}
                                    </div>
                                    <div>
                                      <strong>Sessions:</strong>
                                      {"$" +
                                        priceCalculateHelper({
                                          selectedClass: selectedClassHelper({
                                            classId: values?.classId?.value,
                                            classes,
                                          }),
                                          values,
                                          selectedCoupon: coupon,
                                          lessons: selected?.map(
                                            (lesson) => lesson?.value
                                          ),
                                        })?.classAmountTotal}
                                    </div>
                                    {/* - You will be billed on{" "} */}
                                    {/* {
                                      renderTerms(terms)?.find(
                                        (term) => term?.value === values?.term
                                      )?.payment_date
                                    } */}
                                  </>
                                ) : selectedClassHelper({
                                  classId: values?.classId?.value,
                                  classes,
                                })?.paymentType === "paid" ||
                                  priceCalculateHelper({
                                    selectedClass: selectedClassHelper({
                                      classId: values?.classId?.value,
                                      classes,
                                    }),
                                    values,
                                    selectedCoupon: coupon,
                                    lessons: selected?.map(
                                      (lesson) => lesson?.value
                                    ),
                                  })?.totalAmountToPay > 0 ? (
                                  <>
                                    <div>
                                      <strong>Kit: </strong>
                                      {"$" +
                                        priceCalculateHelper({
                                          selectedClass: selectedClassHelper({
                                            classId: values?.classId?.value,
                                            classes,
                                          }),
                                          values,
                                          selectedCoupon: coupon,
                                          lessons: selected?.map(
                                            (lesson) => lesson?.value
                                          ),
                                        })?.totalOrderAmount}
                                    </div>
                                    <div>
                                      <strong>Sessions: </strong>
                                      {"$" +
                                        priceCalculateHelper({
                                          selectedClass: selectedClassHelper({
                                            classId: values?.classId?.value,
                                            classes,
                                          }),
                                          values,
                                          selectedCoupon: coupon,
                                          lessons: selected?.map(
                                            (lesson) => lesson?.value
                                          ),
                                        })?.classAmountTotal}
                                    </div>
                                    {selected?.some(
                                      (lesson) => lesson?.isMatchDay
                                    ) && (
                                        <div>
                                          <strong>Match Days: </strong>
                                          {// selected?.filter(
                                            //   (lesson) => lesson?.isMatchDay
                                            // ).length
                                            "$" +
                                            priceCalculateHelper({
                                              selectedClass: selectedClassHelper({
                                                classId: values?.classId?.value,
                                                classes,
                                              }),
                                              values,
                                              selectedCoupon: coupon,
                                              lessons: selected?.map(
                                                (lesson) => lesson?.value
                                              ),
                                            })?.totalMatchDayAmount}
                                        </div>
                                      )}
                                    {priceCalculateHelper({
                                      selectedClass: selectedClassHelper({
                                        classId: values?.classId?.value,
                                        classes,
                                      }),
                                      values,
                                      selectedCoupon: coupon,
                                      lessons: selected?.map(
                                        (lesson) => lesson?.value
                                      ),
                                    })?.adminFee > 0 ? (
                                      <div>
                                        <strong>Admin Fee: </strong>
                                        {"$" +
                                          priceCalculateHelper({
                                            selectedClass: selectedClassHelper({
                                              classId: values?.classId?.value,
                                              classes,
                                            }),
                                            values,
                                            selectedCoupon: coupon,
                                            lessons: selected?.map(
                                              (lesson) => lesson?.value
                                            ),
                                          })?.adminFee}
                                      </div>

                                    ) : null}


                                    {
                                      priceCalculateHelper({
                                        selectedClass: selectedClassHelper({
                                          classId: values?.classId?.value,
                                          classes,
                                        }),
                                        values,
                                        selectedCoupon: coupon,
                                        lessons: selected?.map(
                                          (lesson) => lesson?.value
                                        ),
                                      })?.totalAmountToPay > 0 ?
                                        <div>
                                          <strong>Transaction Fee: </strong>
                                          {"$" +
                                            cardAndBankChargesHelper(priceCalculateHelper({
                                              selectedClass: selectedClassHelper({
                                                classId: values?.classId?.value,
                                                classes,
                                              }),
                                              values,
                                              selectedCoupon: coupon,
                                              lessons: selected?.map(
                                                (lesson) => lesson?.value
                                              ),
                                            })?.totalAmountToPay,
                                              business == "ginger"
                                                ?
                                                values.paymentType == "credit" ? gingerSetting.stripe_fee_cc : gingerSetting.stripe_fee_bank
                                                :
                                                values.paymentType == "credit" ? questSetting.stripe_fee_cc : questSetting.stripe_fee_bank
                                            )
                                          }
                                        </div> : <div>
                                          <strong>Transaction Fee: </strong>$0
                                        </div>
                                    }

                                    <hr />
                                    <div>
                                      <strong>Total Price: </strong>
                                      {"$" +
                                        cardAndBankChargesWithTotalHelper(priceCalculateHelper({
                                          selectedClass: selectedClassHelper({
                                            classId: values?.classId?.value,
                                            classes,
                                          }),
                                          values,
                                          selectedCoupon: coupon,
                                          lessons: selected?.map(
                                            (lesson) => lesson?.value
                                          ),
                                        })?.totalAmountToPay, business == "ginger"
                                          ?
                                          values.paymentType == "credit" ? gingerSetting.stripe_fee_cc : gingerSetting.stripe_fee_bank
                                          :
                                          values.paymentType == "credit" ? questSetting.stripe_fee_cc : questSetting.stripe_fee_bank)
                                      }
                                    </div>
                                  </>
                                ) : (
                                  "Free"
                                )}
                              </span>
                              <br />
                              <br />
                            </>
                          ) : null
                        ) : (
                          <>
                            <span style={{ fontSize: "15px" }}>
                              {values?.term === "next" &&
                                values?.paymentOption === "term" ? (
                                <>
                                  <div>
                                    <strong>Price:</strong>
                                    {"$" +
                                      priceCalculateHelper({
                                        selectedClass: selectedClassHelper({
                                          classId: values?.classId?.value,
                                          classes,
                                        }),
                                        values,
                                        selectedCoupon: coupon,
                                        lessons: selected?.map(
                                          (lesson) => lesson?.value
                                        ),
                                      })?.classAmountTotal}
                                  </div>
                                  {/* - You will be billed on */}
                                  {/* {
                                    renderTerms(terms)?.find(
                                      (term) => term?.value === values?.term
                                    )?.payment_date
                                  } */}
                                </>
                              ) : (selectedClassHelper({
                                classId: values?.classId?.value,
                                classes,
                              })?.paymentType === "paid" &&
                                values?.paymentOption !== "monthly") ||
                                (priceCalculateHelper({
                                  selectedClass: selectedClassHelper({
                                    classId: values?.classId?.value,
                                    classes,
                                  }),
                                  values,
                                  selectedCoupon: coupon,
                                  lessons: selected?.map(
                                    (lesson) => lesson?.value
                                  ),
                                })?.totalAmountToPay > 0 &&
                                  values?.paymentOption !== "monthly") ? (
                                <>
                                { priceCalculateHelper({
                                        selectedClass: selectedClassHelper({
                                          classId: values?.classId?.value,
                                          classes,
                                        }),
                                        values,
                                        selectedCoupon: coupon,
                                        lessons: selected?.map(
                                          (lesson) => lesson?.value
                                        ),
                                      })?.classAmountTotal > 0 ? (
                                  <div>
                                    <strong>Price: </strong>
                                    {"$" +
                                      priceCalculateHelper({
                                        selectedClass: selectedClassHelper({
                                          classId: values?.classId?.value,
                                          classes,
                                        }),
                                        values,
                                        selectedCoupon: coupon,
                                        lessons: selected?.map(
                                          (lesson) => lesson?.value
                                        ),
                                      })?.classAmountTotal}
                                  </div> ) : null }
                                  {
                                    priceCalculateHelper({
                                      selectedClass: selectedClassHelper({
                                        classId: values?.classId?.value,
                                        classes,
                                      }),
                                      values,
                                      selectedCoupon: coupon,
                                      lessons: selected?.map(
                                        (lesson) => lesson?.value
                                      ),
                                    })?.totalAmountToPay > 0 ?
                                      <div>
                                        <strong>Transaction Fee: </strong>
                                        {"$" +
                                          // priceCalculateHelper({
                                          //   selectedClass: selectedClassHelper({
                                          //     classId: values?.classId?.value,
                                          //     classes,
                                          //   }),
                                          //   values,
                                          //   selectedCoupon: coupon,
                                          //   lessons: selected?.map(
                                          //     (lesson) => lesson?.value
                                          //   ),
                                          // })?.classAmountTotal}
                                          cardAndBankChargesHelper(priceCalculateHelper({
                                            selectedClass: selectedClassHelper({
                                              classId: values?.classId?.value,
                                              classes,
                                            }),
                                            values,
                                            selectedCoupon: coupon,
                                            lessons: selected?.map(
                                              (lesson) => lesson?.value
                                            ),
                                          })?.totalAmountToPay,
                                            business == "ginger"
                                              ?
                                              values.paymentType == "credit" ? gingerSetting.stripe_fee_cc : gingerSetting.stripe_fee_bank
                                              :
                                              values.paymentType == "credit" ? questSetting.stripe_fee_cc : questSetting.stripe_fee_bank
                                          )
                                        }
                                      </div> :
                                      <div>
                                        <strong>Transaction Fee: </strong> $0
                                      </div>
                                  }



                                  {selected?.some(
                                    (lesson) => lesson?.isMatchDay
                                  ) && (
                                      <div>
                                        <strong>Match Days: </strong>
                                        {// selected?.filter(
                                          //   (lesson) => lesson?.isMatchDay
                                          // ).length
                                          "$" +
                                          priceCalculateHelper({
                                            selectedClass: selectedClassHelper({
                                              classId: values?.classId?.value,
                                              classes,
                                            }),
                                            values,
                                            selectedCoupon: coupon,
                                            lessons: selected?.map(
                                              (lesson) => lesson?.value
                                            ),
                                          })?.totalMatchDayAmount}
                                      </div>
                                    )}
                                  {priceCalculateHelper({
                                    selectedClass: selectedClassHelper({
                                      classId: values?.classId?.value,
                                      classes,
                                    }),
                                    values,
                                    selectedCoupon: coupon,
                                    lessons: selected?.map(
                                      (lesson) => lesson?.value
                                    ),
                                  })?.adminFee > 0 ? (
                                    <div>
                                      { priceCalculateHelper({
                                        selectedClass: selectedClassHelper({
                                          classId: values?.classId?.value,
                                          classes,
                                        }),
                                        values,
                                        selectedCoupon: coupon,
                                        lessons: selected?.map(
                                          (lesson) => lesson?.value
                                        ),
                                      })?.classAmountTotal > 0 ? <strong>Admin Fee: </strong> : <strong>Price: </strong>
                                    }
                                      {"$" +
                                        priceCalculateHelper({
                                          selectedClass: selectedClassHelper({
                                            classId: values?.classId?.value,
                                            classes,
                                          }),
                                          values,
                                          selectedCoupon: coupon,
                                          lessons: selected?.map(
                                            (lesson) => lesson?.value
                                          ),
                                        })?.adminFee}
                                    </div>
                                  ) : null}
                                </>
                              ) : (
                                !values?.paymentOption && "Free"
                              )}
                            </span>
                            <br />
                          </>
                        )}

                        {(!isClassFullHelper(
                          selectedClassHelper({
                            classId: values?.classId?.value,
                            classes,
                          })
                        ) &&
                          values.paymentOption === "full") ||
                          (!isClassFullHelper(
                            selectedClassHelper({
                              classId: values?.classId?.value,
                              classes,
                            })
                          ) &&
                            values.paymentOption === "term") ? (
                          <>
                            <strong style={{ fontSize: "15px" }}>
                              Sessions:
                            </strong>
                            <p>
                              {parseLessonsNamesHelper({
                                sessions: selected?.map(
                                  (lesson) => lesson.value
                                ),
                                allLessons: selectedClassHelper({
                                  classId: values?.classId?.value,
                                  classes,
                                })?.lessons,
                              })}
                            </p>
                          </>
                        ) : null}

                        {console.log(match)}
                        <div className="row">
                          {selectedClassHelper({
                            classId: values?.classId?.value,
                            classes,
                          })?.payment?.length > 1 && (
                              <PaymentMessage
                                questForm={match?.params?.business === "quest"}
                                paymentOption={values.paymentOption}
                                isQuestWeekly={values.isQuestWeekly}
                                selectClass={selectedClassHelper({
                                  classId: values?.classId?.value,
                                  classes,
                                })}
                                kitMandatory={
                                  selectedClassHelper({
                                    classId: values?.classId?.value,
                                    classes,
                                  })?.kit_mandatory
                                }
                                selectedClass={selectedClassHelper({
                                  classId: values?.classId?.value,
                                  classes,
                                })}
                                priceObject={priceCalculateHelper({
                                  selectedClass: selectedClassHelper({
                                    classId: values?.classId?.value,
                                    classes,
                                  }),
                                  values,
                                  selectedCoupon: coupon,
                                  lessons: selected?.map(
                                    (lesson) => lesson?.value
                                  ),
                                })}
                                questSetting={questSetting}
                                gingerSetting={gingerSetting}
                                business={business}
                                paymentType={values.paymentType}
                              />
                            )}
                          {(!user?.paymentMethods?.bankAccounts &&
                            !user?.paymentMethods?.allCards) ||
                            (user?.stripe_customer_id &&
                              user?.paymentMethods?.bankAccounts?.length === 0 &&
                              user?.stripe_customer_id &&
                              user?.paymentMethods?.allCards?.length === 0) ||
                            match?.params?.business !== user?.business ? (
                            <>
                              {(!isClassFullHelper(
                                selectedClassHelper({
                                  classId: values?.classId?.value,
                                  classes,
                                })
                              ) &&
                                selectedClassHelper({
                                  classId: values?.classId?.value,
                                  classes,
                                })?.include_kit &&
                                ((selectedClassHelper({
                                  classId: values?.classId?.value,
                                  classes,
                                }).product &&
                                  !selectedClassHelper({
                                    classId: values?.classId?.value,
                                    classes,
                                  })?.kit_mandatory &&
                                  isFreeKit &&
                                  values?.paymentOption === "full" &&
                                  values.childs.every(
                                    (child) => child.merchandise === "no"
                                  ) &&
                                  selectedClassHelper({
                                    classId: values?.classId?.value,
                                    classes,
                                  })?.service?.service ===
                                  "Childcare Fun Soccer") ||
                                  (!isClassFullHelper(
                                    selectedClassHelper({
                                      classId: values?.classId?.value,
                                      classes,
                                    })
                                  ) &&
                                    selectedClassHelper({
                                      classId: values?.classId?.value,
                                      classes,
                                    })?.include_kit &&
                                    selectedClassHelper({
                                      classId: values?.classId?.value,
                                      classes,
                                    }).product &&
                                    !selectedClassHelper({
                                      classId: values?.classId?.value,
                                      classes,
                                    })?.kit_mandatory &&
                                    isFreeKit &&
                                    values?.paymentOption === "full" &&
                                    values.childs.every(
                                      (child) => child.merchandise === "no"
                                    ) &&
                                    selectedClassHelper({
                                      classId: values?.classId?.value,
                                      classes,
                                    })?.service?.service ===
                                    "Weekly Fun Soccer") ||
                                  (selectedClassHelper({
                                    classId: values?.classId?.value,
                                    classes,
                                  }) &&
                                    selectedClassHelper({
                                      classId: values?.classId?.value,
                                      classes,
                                    })?.include_kit &&
                                    selectedClassHelper({
                                      classId: values?.classId?.value,
                                      classes,
                                    })?.service?.service ===
                                    "Childcare Fun Soccer" &&
                                    !selectedClassHelper({
                                      classId: values?.classId?.value,
                                      classes,
                                    })?.kit_mandatory &&
                                    isFreeKit &&
                                    values?.paymentOption === "full" &&
                                    values.childs.every(
                                      (child) => child.merchandise === "no"
                                    )))) ||
                                (selectedClassHelper({
                                  classId: values?.classId?.value,
                                  classes,
                                }) &&
                                  selectedClassHelper({
                                    classId: values?.classId?.value,
                                    classes,
                                  })?.include_kit &&
                                  selectedClassHelper({
                                    classId: values?.classId?.value,
                                    classes,
                                  })?.service?.service === "Weekly Fun Soccer" &&
                                  !selectedClassHelper({
                                    classId: values?.classId?.value,
                                    classes,
                                  })?.kit_mandatory &&
                                  isFreeKit &&
                                  values?.paymentOption === "full" &&
                                  values.childs.every(
                                    (child) => child.merchandise === "no"
                                  )) ? (
                                <div className=" col-sm-12 col-md-6">
                                  <div className="form-group">
                                    <Field
                                      name={`size`}
                                      component={Select}
                                      validate={() =>
                                        validateKitSize(
                                          values,
                                          selectedClassHelper({
                                            classId: values?.classId?.value,
                                            classes,
                                          })
                                        )
                                      }
                                    >
                                      {({ field, form, meta }) => (
                                        <>
                                          <label>
                                            Please select the size for your Free
                                            kit
                                          </label>
                                          <select
                                            {...field}
                                            name={`size`}
                                            className={`form-control`}
                                            id="size"
                                            style={{
                                              border:
                                                meta.touched && meta.error
                                                  ? "red 1px solid"
                                                  : "",
                                            }}
                                          >
                                            <option value="">Select</option>
                                            {selectedClassHelper({
                                              classId: values?.classId?.value,
                                              classes,
                                            })?.product?.attributes?.map(
                                              (attribute) => {
                                                return (
                                                  <option
                                                    key={attribute?.label}
                                                    value={attribute?.label}
                                                  >
                                                    {attribute?.label}
                                                  </option>
                                                );
                                              }
                                            )}
                                          </select>
                                          {meta.touched && meta.error && (
                                            <div className="error invalid-feedback">
                                              {meta.error}
                                            </div>
                                          )}
                                        </>
                                      )}
                                    </Field>
                                  </div>
                                </div>
                              ) : null}

                              {(user?.business === match?.params?.business &&
                                !user?.paymentMethods?.bankAccounts &&
                                !user?.paymentMethods?.allCards) ||
                                (user?.business === match?.params?.business &&
                                  user?.stripe_customer_id &&
                                  user?.paymentMethods?.bankAccounts?.length ===
                                  0 &&
                                  user?.stripe_customer_id &&
                                  user?.paymentMethods?.allCards?.length === 0) ||
                                user?.business !== match?.params?.business ? (
                                !isClassFullHelper(
                                  selectedClassHelper({
                                    classId: values?.classId?.value,
                                    classes,
                                  })
                                ) &&
                                  !priceCalculateHelper({
                                    selectedClass: selectedClassHelper({
                                      classId: values?.classId?.value,
                                      classes,
                                    }),
                                    values,
                                    selectedCoupon: coupon,
                                    lessons: selected?.map(
                                      (lesson) => lesson?.value
                                    ),
                                  })?.paid &&
                                  values.paymentOption === "full" ? null : (
                                  <div className="col-sm-12 col-md-12">
                                    <div className="form-group">
                                      <Field
                                        type="select"
                                        name="paymentType"
                                        component={Select}
                                      >
                                        {({ field, form, meta }) => (
                                          <div>
                                            <label>Payment Method</label>
                                            <select
                                              {...field}
                                              className={`${getInputClasses(
                                                meta
                                              )}`}
                                              name="paymentType"
                                            >
                                              {paymentMethods &&
                                                paymentMethods.map(
                                                  (payment) => (
                                                    <option
                                                      key={payment.value}
                                                      value={payment.value}
                                                    >
                                                      {payment.text}
                                                    </option>
                                                  )
                                                )}
                                            </select>

                                            {meta.touched && meta.error && (
                                              <div className="error invalid-feedback">
                                                {meta.error}
                                              </div>
                                            )}
                                          </div>
                                        )}
                                      </Field>
                                    </div>
                                  </div>
                                )
                              ) : null}
                            </>
                          ) : null}
                        </div>

                        {(!user?.paymentMethods?.bankAccounts &&
                          !user?.paymentMethods?.allCards) ||
                          (user?.stripe_customer_id &&
                            user?.paymentMethods?.bankAccounts?.length === 0 &&
                            user?.stripe_customer_id &&
                            user?.paymentMethods?.allCards?.length === 0) ||
                          user?.business !== match?.params?.business ? (
                          <>
                            {!isClassFullHelper(
                              selectedClassHelper({
                                classId: values?.classId?.value,
                                classes,
                              })
                            ) &&
                              !priceCalculateHelper({
                                selectedClass: selectedClassHelper({
                                  classId: values?.classId?.value,
                                  classes,
                                }),
                                values,
                                selectedCoupon: coupon,
                                lessons: selected?.map((lesson) => lesson?.value),
                              })?.paid &&
                              values.paymentOption === "full" &&
                              user?.business ===
                              match?.params?.business ? null : values &&
                                values.paymentType == "credit" ? (
                              <>
                                <div className="row">
                                  <div className="col-sm-12 col-md-12">
                                    {" "}
                                    <div className="form-group">
                                      <Field
                                        type="text"
                                        name="accountHolderName"
                                        component={Input}
                                      >
                                        {({ field, form, meta }) => (
                                          <div>
                                            <label htmlFor="accountHolderName">
                                              Account Holder Name
                                            </label>
                                            <input
                                              type="text"
                                              {...field}
                                              className={`${getInputClasses(
                                                meta
                                              )}`}
                                              id="accountHolderName"
                                            />
                                            {meta.touched && meta.error && (
                                              <div className="error invalid-feedback">
                                                {meta.error}
                                              </div>
                                            )}
                                          </div>
                                        )}
                                      </Field>
                                    </div>
                                  </div>
                                </div>

                                <div className="row">
                                  <div className="col-sm-12 col-md-12">
                                    <div className="form-group">
                                      <label id="my-radio-group">
                                        Enter Card Details
                                      </label>
                                      <Field name="stripeId">
                                        {() => <CardElement hidePostalCode />}
                                      </Field>
                                    </div>
                                  </div>
                                </div>
                              </>
                            ) : null}

                            {!isClassFullHelper(
                              selectedClassHelper({
                                classId: values?.classId?.value,
                                classes,
                              })
                            ) &&
                              !priceCalculateHelper({
                                selectedClass: selectedClassHelper({
                                  classId: values?.classId?.value,
                                  classes,
                                }),
                                values,
                                selectedCoupon: coupon,
                                lessons: selected?.map((lesson) => lesson?.value),
                              })?.paid &&
                              values.paymentOption === "full" ? null : values &&
                                values.paymentType == "direct" ? (
                              <div className="row">
                                <div className="col-sm-12 col-md-12">
                                  <div className="form-group">
                                    <label id="my-radio-group">
                                      Enter Bank Details
                                    </label>
                                    <Field name="stripeId">
                                      {() => (
                                        <AuBankAccountElement
                                          options={
                                            AU_BANK_ACCOUNT_ELEMENT_OPTIONS
                                          }
                                        />
                                      )}
                                    </Field>
                                    {/* Display mandate acceptance text. */}
                                    <div className="mandate-acceptance mt-4">
                                      By providing your bank account details,
                                      you agree to this Direct Debit Request and
                                      the{" "}
                                      <a href="https://stripe.com/au-becs-dd-service-agreement/legal">
                                        Direct Debit Request service agreement
                                      </a>
                                      , and authorise Stripe Payments Australia
                                      Pty Ltd ACN 160 180 343 Direct Debit User
                                      ID number 507156 (“Stripe”) to debit your
                                      account through the Bulk Electronic
                                      Clearing System (BECS) on behalf of
                                      Rocketship Inc. (the "Merchant") for any
                                      amounts separately communicated to you by
                                      the Merchant. You certify that you are
                                      either an account holder or an authorised
                                      signatory on the account listed above.
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : null}
                          </>
                        ) : null}
                      </>
                    ) : null}

                    {!isClassFullHelper(
                      selectedClassHelper({
                        classId: values?.classId?.value,
                        classes,
                      })
                    ) &&
                      ((isFreeKit &&
                        selectedClassHelper({
                          classId: values?.classId?.value,
                          classes,
                        })?.product?._id &&
                        selectedClassHelper({
                          classId: values?.classId?.value,
                          classes,
                        })?.include_kit &&
                        !selectedClassHelper({
                          classId: values?.classId?.value,
                          classes,
                        })?.kit_mandatory &&
                        !values.isQuestWeekly &&
                        values.paymentOption === "full" &&
                        values.childs.some(
                          (child) =>
                            (child.merchandise === "yes" && !child.quantity) ||
                            (child.merchandise === "yes" &&
                              parseInt(child.quantity) <= 0) ||
                            (child.merchandise === "yes" && !child.size) ||
                            (child.merchandise === "yes" &&
                              parseInt(child.size) <= 0)
                        )) ||
                        (isFreeKit &&
                          selectedClassHelper({
                            classId: values?.classId?.value,
                            classes,
                          })?.product?._id &&
                          selectedClassHelper({
                            classId: values?.classId?.value,
                            classes,
                          })?.include_kit &&
                          !selectedClassHelper({
                            classId: values?.classId?.value,
                            classes,
                          })?.kit_mandatory &&
                          !values.isQuestWeekly &&
                          values.paymentOption === "full" &&
                          values.childs.every(
                            (child) => child.merchandise === "no"
                          ) &&
                          !values.size)) ? (
                      <Alert variant="danger">
                        <strong>
                          Please select the size for your Free kit.
                        </strong>
                      </Alert>
                    ) : null}

                    {(noChildError &&
                      values?.childs?.length === 0 &&
                      values?.studentIds?.length === 0) ||
                      (noChildError &&
                        values?.childs?.length === 0 &&
                        !values?.studentIds) ? (
                      <Alert variant="danger">
                        <strong>{noChildError}</strong>
                      </Alert>
                    ) : null}

                    {enrolmentError || exist ? (
                      <Alert variant="danger">
                        {exist && (
                          <strong>
                            An account already exist with this email address.
                            Please{" "}
                            <span
                              style={{
                                cursor: "pointer",
                                color: "blue",
                              }}
                              onClick={showModal}
                              href="javascript:void(0)"
                            >
                              login
                            </span>{" "}
                            to checkout.
                          </strong>
                        )}
                        {!exist && enrolmentError && (
                          <strong>
                            {!exist && enrolmentError && enrolmentError}
                          </strong>
                        )}
                      </Alert>
                    ) : null}

                    {!isClassFullHelper(
                      selectedClassHelper({
                        classId: values?.classId?.value,
                        classes,
                      })
                    ) &&
                      values.classId &&
                      selectedClassHelper({
                        classId: values.classId.value,
                        classes,
                      })?.paymentType === "free" &&
                      selectedClassHelper({
                        classId: values?.classId?.value,
                        classes,
                      })?.allow_individual_date_bookings &&
                      priceCalculateHelper({
                        selectedClass: selectedClassHelper({
                          classId: values?.classId?.value,
                          classes,
                        }),
                        values,
                        selectedCoupon: coupon,
                        lessons: selected?.map((lesson) => lesson?.value),
                      })?.totalAmountToPay <= 0 && (
                        <>
                          <strong style={{ fontSize: "15px" }}>Sessions</strong>
                          <p>
                            {parseLessonsNamesHelper({
                              sessions: selected?.map((lesson) => lesson.value),
                              allLessons: selectedClassHelper({
                                classId: values?.classId?.value,
                                classes,
                              })?.lessons,
                            })}
                          </p>
                        </>
                      )}

                    <div className="form-group">
                      <Field type="checkbox" name="termsAndConditions">
                        {({ field, form, meta }) => (
                          <>
                            <label>
                              <input
                                type="checkbox"
                                name="termsAndConditions"
                                {...field}
                              />{" "}
                              I acknowledge that I have read and understood the
                              FAQs and other relevant information available on
                              the website and I agree to the{" "}
                              <a
                                target="blank"
                                href={
                                  match.params.business === "ginger"
                                    ? "https://gingersport.com.au/policy/terms/"
                                    : match.params.business === "quest" &&
                                    "https://questfa.com.au/terms-conditions/"
                                }
                              >
                                terms of service
                              </a>{" "}
                              .
                            </label>
                            {meta.touched && meta.error && (
                              <div
                                style={{
                                  color: "#F64E60",
                                  fontWeight: 400,
                                  fontSize: "0.9rem",
                                }}
                              >
                                {meta.error}
                              </div>
                            )}
                          </>
                        )}
                      </Field>
                    </div>

                    {/* {values && values.classId && (
                      <TermsComponent
                        terms={
                          selectedClassHelper({
                            classId: values?.classId?.value,
                            classes,
                          })?.terms
                        }
                      />
                    )} */}
                    <div className="form-group d-flex flex-wrap ">
                      {spin ? (
                        <button
                          className="btn btn-primary spinner spinner-white spinner-left"
                          type="button"
                          disabled
                        >
                          <span> Submit</span>
                        </button>
                      ) : (
                        <button
                          className={`btn btn-primary ${spin ? "spinner spinner-white spinner-left" : ""
                            }`}
                          type="submit"
                          disabled={spin || exist ? true : false}
                        >
                          <span> Submit</span>
                        </button>
                      )}
                    </div>
                  </form>
                </div>
              </>
            )}
          </Formik>
        </>
      )}
    </div>
  );
};

export default function InjectedPaymentSetupForm(props) {
  return (
    <ElementsConsumer>
      {({ stripe, elements }) => (
        <EnrolmentForm stripe={stripe} elements={elements} {...props} />
      )}
    </ElementsConsumer>
  );
}
